export const lang = {
	str_title: `ภาษาจีน`,
	str_index: `หน้าแรก`,
	str_neiye: 'Lobby',
	str_activity: `กิจกรรม`,
	str_service: `บริการลูกค้า`,
	str_my: `ของฉัน `,
	str_more: `เพิ่มขึ้น `,
	str_save: `บันทึก`,
	str_sure: `ยืนยัน`,
	str_update: `อัปเดต `,
	str_serviceName: `ติดต่อฝ่ายบริการลูกค้า`,
	str_confirm: `ยืนยัน`,
	str_tabs_charge: `เติมเงิน`,
	str_tabs_Withdrawal: `การถอนเงิน`,
	str_tabs_integral: `คะแนน `,
	str_tabs_activity: `กิจกรรม`,
	str_loginBefore: `ไม่ได้เข้าสู่ระบบ`,
	str_loginBeforeBalance: `ตรวจสอบหลังจากเข้าสู่ระบบ`,
	str_1_8: `ลอตเตอรี่ 1 นาที`,
	str_1_9: `ลอตเตอรี่ 5 นาที`,
	str_1_10: `แข่ง 5 นาที`,
	str_1_11: `แข่ง 1 นาที`,
	str_1_12: `1 วินาที Sic Bo`,
	str_1_13: `Sic Bo 1 นาที`,
	str_1_14: `1 วินาที มาร์ค ซิกซ์`,
	str_1_15: `ลอตเตอรี 6 นาที 1 นาที`,
	str_1_27: `แผ่นสี 1 วินาที`,
	str_1_28: `ดิสก์สี 1 นาที`,
	str_1_29: `ปลา กุ้ง ปู 1 วินาที`,
	str_1_30: `ปลา กุ้ง ปู 1 นาที`,
	str_1_31: `เดา 1 วินาที`,
	str_1_32: `เดา 1 แต้ม`,
	str_1_203: `หวยใต้1`,
	str_1_204: `กลาง 1 หวย`,
	str_1_205: `หวยเหนือ1`,
	str_1_100: `มาสคอต`,
	str_1_101: `ฟาฟาฟา`,
	str_1_102: `ศึกสามก๊ก`,
	str_1_103: `แวมไพร์`,
	str_1_104: `สมบัติอียิปต์`,
	str_1_1000: `ราชามังกรทะเลจีนตะวันออก`,
	str_1_1001: `ตกปลาดาว`,
	str_1_1002: `ตกปลาคลาสสิก`,
	str_1_1003: `ตกปลา`,
	str_1_1004: `เกมส์ตกปลา`,
	str_100_30300101: `สมบัติมังกร`,
	str_100_30300501: `โกคูตกปลา`,
	str_100_30300201: `วัวเงินสด`,
	str_100_30300301: `ตกปลาคางคกทอง`,
	str_100_30300401: `หลี่กุยแยกปลา`,
	str_100_30300601: `ต้าเซิง นาวไห่`,
	str_100_30300701: `จระเข้สามสี`,
	str_1_105: `โฮจิมินห์`,
	str_1_106: `หอทองแดง`,
	str_1_107: `กาเมา`,
	str_1_108: `เบน เทร`,
	str_1_109: `หวุงเต่า`,
	str_1_110: `Bac Lieu`,
	str_1_111: `ดงนาย`,
	str_1_112: `คันโถ`,
	str_1_113: `ซกตรัง`,
	str_1_114: `ซีหนิง`,
	str_1_115: `อันเกียง`,
	str_1_116: `เรียบ`,
	str_1_117: `วิงลุง`,
	str_1_118: `บินห์เดือง`,
	str_1_119: `ชาโรง`,
	str_1_120: `ลองอัน`,
	str_1_121: `บินห์ฟุก`,
	str_1_122: `Hao Jiang`,
	str_1_123: `เทียนเจียง`,
	str_1_124: `เจี้ยนเจียง`,
	str_1_125: `ดาลัด`,
	str_1_126: `ซุ่นหัว`,
	str_1_127: `ฟู่อัน`,
	str_1_128: `เดเล่`,
	str_1_129: `กว๋างนาม`,
	str_1_130: `ดานัง`,
	str_1_131: `ชิงเหอ`,
	str_1_132: `Ping Ding`,
	str_1_133: `GuangZhi`,
	str_1_134: `Quang bình`,
	str_1_135: `จาลาย`,
	str_1_136: `นิงถ่วน`,
	str_1_137: `ความหมายกว้าง`,
	str_1_138: `เดลลอน`,
	str_1_139: `Kunsong`,
	str_1_140: `โฮจิมินห์ VIP`,
	str_1_200: `ภาคเหนือ`,
	str_1_201: `ล็อตโต้ 18h25`,
	str_1_202: `ฮานอย VIP`,
	str_1_206: `ล็อตโต้ สลาก 1 เซ็นต์`,
	str_1_300: `ทดสอบลอตเตอรี่เวียดนามหนึ่งคะแนน`,
	str_1_301: 'อำนาจของมังกรและเสือ',
	str_1_302: 'ธันเดอร์ซุส',
	str_1_303: `ซาฮาราไนท์`,
	str_1_304: `ความมั่งคั่งของ Zeda`,
	str_2_0: `ล็อบบี้ฟุตบอลโลก`,
	str_8_0: `BBIN ล็อบบี้`,
	str_10_0: `ดีจี ฮอลล์`,
	str_9_0: `เซ็กซี่ ฮอลล์`,
	str_2_101: `บาคาร่า`,
	str_2_102: `เสือมังกร`,
	str_2_103: `รูเล็ต`,
	str_2_104: `ซิกโบ`,
	str_2_105: `นิว นิว`,
	str_2_106: `ซังกง`,
	str_2_107: `ฟานทัน`,
	str_2_108: `แผ่นดิสก์สี`,
	str_2_110: `ปลา กุ้ง และปู`,
	str_2_111: `ดอกไม้สีทองทอด`,
	str_2_112: `เวินโจว ปาย โกว`,
	str_2_113: `28 แท่ง`,
	str_2_114: `อันดาบาฮา`,
	str_5_Unknown: ``,
	str_5_Soccer: `ฟุตบอล`,
	str_5_Basketball: `บาสเกตบอล`,
	str_5_Football: `อเมริกันฟุตบอล`,
	str_5_IceHockey: `puck`,
	str_5_Badminton: `แบดมินตัน`,
	str_5_Pool: `บิลเลียด/สนุกเกอร์`,
	str_5_Motor_Sport: `แข่งรถ`,
	str_5_Tennis: `เทนนิส`,
	str_5_5_Baseball: `เบสบอล`,
	str_5_Volleyball: `วอลเลย์บอล`,
	str_5_Others: `อื่น ๆ`,
	str_5_Golf: `กอล์ฟ`,
	str_5_Boxing: `มวย`,
	str_5_Cricket: `คริกเก็ต`,
	str_5_Table_Tennis: `เทเบิลเทนนิส`,
	str_5_Rugby: `รักบี้`,
	str_5_Handball: `แฮนด์บอล`,
	str_5_Cycling: `จักรยาน`,
	str_5_Athletics: `กรีฑา`,
	str_5_Beach_Soccer: `ฟุตบอลชายหาด`,
	str_5_Futsal: `ฟุตบอลในร่ม`,
	str_5_Entertainment: `มีเอกลักษณ์`,
	str_5_Financial: `การเงิน`,
	str_5_Darts: `เกมส์ปาเป้า`,
	str_5_Olympic: `โอลิมปิค`,
	str_5_Lacrosse: `ลาครอส`,
	str_5_Water_Polo: `โปโลน้ำ`,
	str_5_Winter_Sports: `กีฬาฤดูหนาว`,
	str_5_Squash: `สควอช`,
	str_5_Field_Hockey: `ฮอกกี้`,
	str_5_Mixed_Martial_Arts: `ศิลปะการต่อสู้แบบผสมผสาน`,
	str_5_E_Sports: `อีสปอร์ต`,
	str_5_Gaelic_Football: `เกลิค ซอคเก้อร์`,
	str_5_Hurling: `板棍球`,
	str_5_Muay_Thai: `มวยไทย`,
	str_5_Aussie_Rules_Football: `ฟุตบอลออสเตรเลียน รูลส์`,
	str_5_Bandy: `แบนดี้บอล`,
	str_5_Winter_Olympics: `โอลิมปิกฤดูหนาว`,
	str_6_1: `ราชาผลไม้เพชร`,
	str_6_8: `น้ำผึ้งหวาน`,
	str_6_60: `การเต้นรำของป่า`,
	str_6_2: `หมากรุกเซนต์`,
	str_6_10: `พรห้าประการมาถึงประตู`,
	str_6_35: `บ้า เนจา`,
	str_6_39: `กำลังบิน`,
	str_6_57: `อำนาจของสัตว์เดรัจฉาน`,
	str_6_54: `ม้าโคลนหญ้าไฟ`,
	str_6_66: `ร้อน 777`,
	str_6_69: `เทพเจ้าแห่งความมั่งคั่ง`,
	str_6_70: `มังกรล้านตัว`,
	str_6_72: `ขอให้โชคดีปีแล้วปีเล่า`,
	str_6_74: `ชามสมบัติ`,
	str_6_76: `ต้องการ ต้องการ ต้องการ`,
	str_6_77: `ไฟฟีนิกซ์`,
	str_6_78: `อพอลโล`,
	str_6_80: `เทพแห่งท้องทะเลในตำนาน`,
	str_6_61: `กินถั่วทุกวัน`,
	str_6_55: `ตำนานมังกร`,
	str_6_68: `หวู่คงขโมยลูกพีช`,
	str_6_204: `หีบสมบัติ`,
	str_6_83: `ราชินีแห่งไฟ`,
	str_6_1074: `ความอุดมสมบูรณ์ JP`,
	str_6_1010: `พรห้าประการ JP`,
	str_6_1067: `รับไข่ทองคำJP`,
	str_6_92: `ฟุตบอลโลกปี 2018`,
	str_6_86: `牛逼快跑`,
	str_6_95: `รองเท้าผ้าใบฟุตบอลโลก`,
	str_6_96: `ลูกฟุตบอล`,
	str_6_98: `ฟุตบอลโลกออลสตาร์`,
	str_6_105: `กระโดดสูงมือเดียว`,
	str_6_104: `จับคู่ริมชายหาด`,
	str_6_122: `อินคา ซูมา`,
	str_6_131: `เทพเจ้าแห่งโชคลาภ Straight`,
	str_6_113: `เทพเจ้าแห่งโชคลาภ Flying`,
	str_6_146: `ตะเกียงสมบัติจูเลียน`,
	str_6_147: `ดอกไม้ที่อุดมสมบูรณ์`,
	str_6_148: `ราวกับพระเจ้า`,
	str_6_157: `มวยห้ารูป`,
	str_6_150: `วันเกิดผมใหญ่`,
	str_6_182: `ธอร์2`,
	str_6_197: `สมบัติปานหลง`,
	str_6_199: `สุขสันต์ เทศกาลน้ำ`,
	str_6_CH03: `บดินทร์`,
	str_6_208: `ต้นไม้เงิน`,
	str_6_207: `ไทย sic BO`,
	str_6_209: `เทพรักน้อย`,
	str_6_5: `ทองใหญ่`,
	str_6_12: `ทองคำและหยกเต็มบ้าน`,
	str_6_16: `ห้าองค์ประกอบ`,
	str_6_36: `ผู้ประกอบการไนท์คลับ`,
	str_6_58: `ไก่ทอง2`,
	str_6_64: `ซุส`,
	str_6_205: `เต้นรำ`,
	str_6_81: `เกาะสมบัติ`,
	str_6_AS08: `ทองมายา`,
	str_6_AS09: `สัตว์เลี้ยงฮอลลีวูด`,
	str_6_AS10: `ลัคกี้3`,
	str_6_AS17: `สมบัติของเซธ`,
	str_6_AS18: `บ้ากัมมี่`,
	str_6_AS19: `เรื่องคริสต์มาส`,
	str_6_AS20: `ราชินีมรณะ`,
	str_6_99: `กระโดดให้สูงขึ้น`,
	str_6_103: `การจับคู่อัญมณี`,
	str_6_102: `ปาร์ตี้ผลไม้`,
	str_6_118: `คนขับรถเก่า`,
	str_6_130: `ขโมยทองสาว`,
	str_6_135: `ไก่ทองสายตรง`,
	str_6_136: `เรียกใช้สัตว์ร้าย`,
	str_6_137: `เต้นตรง`,
	str_6_138: `กระโดดข้าม`,
	str_6_139: `เรือโซ่ไหม้ตรง`,
	str_6_140: `การเผาไหม้เรือโซ่2`,
	str_6_141: `คริสต์มาสอยู่ที่นี่`,
	str_6_142: `วัลแคน`,
	str_6_143: `Fortune Fuwa`,
	str_6_144: `เจาะเพื่อเพิ่มเติม`,
	str_6_AT01: `ตกปลาแปปเดียว`,
	str_6_112: `ขโมยหลุมฝังศพของฟาโรห์`,
	str_6_152: `บินคู่`,
	str_6_153: `น้ำตาลหก`,
	str_6_154: `พ่อของซุส`,
	str_6_160: `เทพเจ้าแห่งความมั่งคั่ง2`,
	str_6_163: `เนจามาอีกแล้ว`,
	str_6_161: `เฮอร์คิวลิส`,
	str_6_173: `666`,
	str_6_183: `หมาป่า ดิสโก้`,
	str_6_CA01: `Yaxing CQ9 สด`,
	str_6_4: `ราชินีแห่งป่าไม้`,
	str_6_9: `จงกุ้ย โชค ฟอร์จูน`,
	str_6_13: `สาวซากุระ`,
	str_6_17: `สิงโตนำโชค`,
	str_6_201: `นักชกมวย`,
	str_6_203: `ตื่นเต้นจัง`,
	str_6_79: `กิ้งก่า`,
	str_6_89: `ธอร์`,
	str_6_AS01: `รองเท้านำโชค`,
	str_6_AS02: `ละครสัตว์บ้า`,
	str_6_AS03: `วิธีฝึกมังกร`,
	str_6_121: `โดดขึ้นไปตรงๆ2`,
	str_6_124: `ล็อคช้างอยู่ยงคงกระพัน`,
	str_6_125: `สเตรท ซุส`,
	str_6_127: `Straight Wusheng`,
	str_6_128: `สร้างรายได้มหาศาล`,
	str_6_129: `ไก่ทองสายตรง 2`,
	str_6_133: `Straight Hongfu Qitian`,
	str_6_AS33: `ความโชคดีของหมู`,
	str_6_3: `จุมพิตแห่งเลือด`,
	str_6_7: `ที่จะกระโดดขึ้น`,
	str_6_15: `การประกาศของไก่ทอง`,
	str_6_19: `ล้อร้อน`,
	str_6_20: `ฟาฟาฟา`,
	str_6_21: `ตำนานหมาป่าป่า`,
	str_6_22: `การเดินทางกิจการทั่วไปสู่ตะวันตก บทที่ 2`,
	str_6_23: `ลิ่มทอง`,
	str_6_24: `ที่จะกระโดดขึ้น2`,
	str_6_26: `777`,
	str_6_27: `โลกเวทมนตร์`,
	str_6_29: `โลกน้ำ`,
	str_6_31: `Wu Sheng`,
	str_6_32: `Detective Di Renjie`,
	str_6_33: `การเผาไหม้เรือโซ่`,
	str_6_34: `การต่อสู้โกเฟอร์`,
	str_6_38: `แค่เต้น`,
	str_6_42: `โฮล์มส์`,
	str_6_44: `ดีลักซ์ ฟรุต คิง`,
	str_6_46: `หมาป่า มูน`,
	str_6_47: `สมบัติของฟาโรห์`,
	str_6_49: `โลนลี่แพลนเน็ต`,
	str_6_50: `หงฟู่ ฉีเถียน`,
	str_6_51: `สวัสดีระเบิดวงเวียนใหญ่`,
	str_6_52: `กระโดดสูง`,
	str_6_202: `สาวเต้น`,
	str_6_67: `รับไข่ทองคำ`,
	str_6_AB3: `ฟาร์มประมงทอง`,
	str_6_59: `อุรังอุตังฤดูร้อน`,
	str_6_180: `การประกาศของไก่ทอง3`,
	str_6_179: `กระโดดสูง2`,
	str_6_GO169: `Lucky Dragon ลูกเหล็กขนาดเล็ก`,
	str_6_185: `ดราก้อนบอล`,
	str_6_186: `ราชินีแห่งไฟ2`,
	str_6_195: `ช้างมั่งคั่ง`,
	str_6_196: `ความสุขทองสิบเท่า`,
	str_6_200: `หนีไปอลิซ`,
	str_6_AS04: `ความมั่งคั่ง Spectre`,
	str_6_108: `กระโดดตรงสูงขึ้น`,
	str_6_109: `กระโดดขึ้นด้วยมือเดียว`,
	str_6_111: `บินขึ้นไป`,
	str_6_115: `ราชินีน้ำแข็ง`,
	str_6_116: ` แดนสวรรค์เดินละเมอ`,
	str_6_117: `TVXQ`,
	str_6_221: `สี่ราชาสวรรค์แห่ง Di Renjie`,
	str_6_123: `พรห้าประการตรงมาที่ประตู`,
	str_6_132: `เมี้ยวอีก`,
	str_6_AT05: `มีความสุขในการตกปลา`,
	str_6_184: `6 แคปซูล`,
	str_6_BT02: `คว้า Zhuang Dice Niu Niu`,
	str_6_187: `หวิงชุน`,
	str_6_188: `คริกเก็ตมาเนีย`,
	str_6_194: `มังกรบินบนฟ้า`,
	str_6_BT03: `คว้าจ้วงหมี่หนิวหนิว`,
	str_6_AT101: `เมอร์เซเดส-เบนซ์ บีเอ็มดับเบิลยู`,
	str_6_5007: `สร้างรายได้`,
	str_6_5008: `แดงใหญ่`,
	str_6_5009: `ความหายนะในสวรรค์`,
	str_6_206: `คริตหวาน`,
	str_6_210: `Woo ga กลัว ga`,
	str_6_212: `ร้อน Westward Journey`,
	str_6_213: `มินิรูเล็ต`,
	str_6_214: `นินจาแรคคูน`,
	str_6_GO01: `ที่ดันเหรียญดราก้อนบอล`,
	str_6_GB1: `321 เปิดตัว`,
	str_6_GB198: `บิงโกลิงสี`,
	str_6_215: `ร้อนและเผ็ด`,
	str_6_211: `อะควาแมน`,
	str_6_GB2: `นักล่าสัตว์ประหลาด`,
	str_6_216: `แผ่นดิสก์สี`,
	str_6_217: `ไพ่นกกระจอกผลไม้`,
	str_6_177: `เด็กชายและตะเกียงวิเศษ`,
	str_6_GB6: `เทพช้างน้อยผู้ร่ำรวย`,
	str_6_218: `达拉崩吧`,
	str_6_219: `กอริลลาทองคำพิเศษ`,
	str_6_220: `This market is dead`,
	str_6_222: `น้ำไทยคำอธิษฐานพระเจ้า`,
	str_6_GB3: `หมุนเหรียญทอง`,
	str_7_0: `ห้องโถง`,
	str_7_620: `เท็กซัส โฮลเอ็ม`,
	str_7_720: `28 แท่ง`,
	str_7_830: `หยิบ Zhuang Niu Niu`,
	str_7_220: `ดอกไม้สีทองทอด`,
	str_7_860: `ซังกง`,
	str_7_900: `เสือมังกรเบตจวง`,
	str_7_600: `21 นาฬิกา`,
	str_7_870: `Tumblr นิวนิว`,
	str_7_230: `ดอกไม้สีทองทอดเร็ว`,
	str_7_730: `คว้า Pai Gow ของนายธนาคาร`,
	str_7_630: `น้ำสิบสาม`,
	str_7_610: `สู้กับเจ้าบ้าน`,
	str_7_910: `บาคาร่า`,
	str_7_920: `ลูกป่า`,
	str_7_930: `วัวร้อยคน`,
	str_7_1950: `10,000 คนทอดดอกไม้สีทอง`,
	str_7_650: `แม่น้ำเลือด`,
	str_7_890: `ดูไพ่และคว้า Zhuang Niuniu`,
	str_7_740: `ไพ่นกกระจอกสำหรับสองคน`,
	str_7_1350: `วงล้อแห่งโชคชะตา (ไม่สามารถเข้าถึงได้แยกต่างหาก)`,
	str_7_1940: `ฉลามทอง ฉลามเงิน`,
	str_7_1960: `เมอร์เซเดส-เบนซ์ บีเอ็มดับเบิลยู`,
	str_7_1980: `100 ซิกโบ`,
	str_7_1810: `หนึ่งต่อโอ้ นิว นิว`,
	str_7_1990: `NI U . ผัด`,
	str_7_1850: `เดิมพันปล้น Zhuang Niuniu`,
	str_7_510: `ตกปลาซองจดหมายสีแดง`,
	str_7_1355: `ลองใช้เลย (ไม่สามารถเข้าถึงแยกกันได้)`,
	str_7_1970: `ห้าดาวหงหุย`,
	str_7_1860: `โป๊กเกอร์คาสิโน`,
	str_7_1370: `ฮ่องกง สตั๊ด`,
	str_7_1690: `ซิกโบเลือด`,
	str_7_1890: `เครื่องผลไม้`,
	str_7_1610: `สมบัตินำโชค (ไม่สามารถเข้าถึงแยกต่างหาก)`,
	str_7_1930: `ปลา กุ้ง ปู`,
	str_7_8130: `วิ่งเร็ว`,
	str_7_950: `สงครามสีแดงและสีดำ`,
	str_7_840: `บ้าคว้า Zhuang Niu Niu`,
	str_7_1710: `แบบทดสอบสงครามม้า (ไม่สามารถเข้าถึงแยกต่างหาก)`,
	str_7_520: `หลี่กุยตกปลา`,
	str_9_MX_LIVE_001: `คลาสสิค บาคาร่า`,
	str_9_MX_LIVE_002: `บาคาร่า`,
	str_9_MX_LIVE_0039: `9_MX_LIVE_003 ประกันบาคาร่า`,
	str_9_MX_LIVE_006: `เสือมังกร`,
	str_9_MX_LIVE_007: `ซิกโบ`,
	str_9_MX_LIVE_009: `รูเล็ต`,
	str_9_MX_LIVE_010: `ลูกเต๋าสีแดงและสีน้ำเงิน`,
	str_10_1: `บาคาร่า`,
	str_10_3: `เสือมังกร`,
	str_10_4: `รูเล็ต`,
	str_10_5: `ซิกโบ`,
	str_10_7: `đấu bò`,
	str_10_6: `ฟานทัน`,
	str_10_8: `การแข่งขันบาคาร่า`,
	str_10_11: `ดอกไม้สีทองทอด`,
	str_10_12: `ซิกโบความเร็ว`,
	str_10_14: `แผ่นดิสก์สี`,
	str_10_15: `ปลา กุ้ง และปู`,
	str_10_51: `สดลัคกี้5`,
	str_10_52: `สดลัคกี้10`,
	str_12_0: `ห้องโถง`,
	str_12_620: `เท็กซัส โฮลเอ็ม`,
	str_12_720: `28 แท่ง`,
	str_12_830: `หยิบ Zhuang Niu Niu`,
	str_12_220: `ดอกไม้สีทองทอด`,
	str_12_860: `ซังกง`,
	str_12_900: `ศึกมังกรกับเสือ`,
	str_12_600: `21 นาฬิกา`,
	str_12_870: `Tumblr นิว นิว`,
	str_12_230: `ดอกไม้สีทองทอดเร็ว`,
	str_12_730: `คว้า Pai Gow ของนายธนาคาร`,
	str_12_630: `น้ำสิบสาม`,
	str_12_610: `สู้กับเจ้าบ้าน`,
	str_12_890: `ดูสาม Grab Zhuang Niu Niu`,
	str_12_910: `บาคาร่า`,
	str_12_950: `สงครามสีแดงและสีดำ`,
	str_12_740: `ไพ่นกกระจอกสำหรับสองคน`,
	str_12_930: `วัวร้อยคน`,
	str_12_510: `ศึกตกปลา`,
	str_12_8120: `การต่อสู้นองเลือด`,
	str_12_920: `ลูกป่า`,
	str_12_8150: `ดูสี่ Grab Zhuang Niu Niu`,
	str_12_8180: `การจับคู่อัญมณี`,
	str_12_8160: `癞子牛牛`,
	str_12_8210: `ลองใช้เลย `,
	str_12_8130: `วิ่งเร็ว`,
	str_12_8200: `หยิบนายธนาคารแล้วเลือกสาม`,
	str_12_8190: `หมื่นคนเข็นกระสวย`,
	str_12_8220: `หยิบซองแดง`,
	str_12_8230: `ล้านซองแดง`,
	str_12_940: `ฉลามทอง ฉลามเงิน`,
	str_12_8260: `ผู้เล่นอันดับหนึ่ง`,
	str_12_8270: `ผัดฉ่าดอกไม้สีทอง`,
	str_12_8280: `ห้องส่วนตัวเพื่อน 8281`,
	str_12_8281: `เพื่อนซองแดงคว้า Grab Zhuang Niu Niu`,
	str_12_8250: `ดริฟท์รถหรู`,
	str_12_8110: `แม่น้ำเลือด`,
	str_12_8310: `เทพเจ้าแห่งโชคลาภมาถึง`,
	str_12_8140: `เครื่องผลไม้`,
	str_12_8340: `สิบโมงครึ่ง`,
	str_12_8320: `สี่เหลี่ยมพลัมสีดำและสีแดง 8330`,
	str_12_8330: `แข่งความเร็ว`,
	str_12_8410: `โป๊กเกอร์คาสิโน`,
	str_12_8450: `ซิกโบ Grab Zhuang Niu Niu`,
	str_12_8460: `Sic Bo ปล้น Zhuang Sangong`,
	str_12_8470: `ซิกโบ ถงบี ซังกง`,
	str_12_8480: `ซิกโบ แดงดำ ซิงเกิ้ลและดับเบิล`,
	str_12_8490: `ซิกโบ การต่อสู้นองเลือด`,
	str_12_8500: `บิ๊กทอล์ค ไดซ์ 067`,
	str_12_8510: `บิ๊กทอล์ค ลูกเต๋าชัย`,
	str_12_8360: `ลิงประหลาด`,
	str_12_8440: `ฮ่องกง สตั๊ด`,
	str_12_8420: `ซ่างจวง วัวร้อยคน`,
	str_12_8282: `บัดดี้รูม Texas Hold'em`,
	str_12_8550: `NI U . ผัด`,
	str_12_8600: `โค่นล้ม Hu`,
	str_12_8640: `ผู้เล่นหลายคน ไฮโล`,
	str_12_8231: `ซองจดหมายสีแดงนำโชค`,
	str_12_8680: `สองคน หนิว หนิว`,
	str_12_8620: `Dice Niu Niu`,
	str_12_8630: `มองด้วยความสิ้นหวัง`,
	str_12_8650: `รุ่นแข่งขัน Grab Zhuang Niu Niu`,
	str_12_8690: `ร้อยคนทอดดอกไม้สีทอง`,
	str_12_8660: `ยูโรเปี้ยนรูเล็ต`,
	str_12_8750: `คลาสสิค สตั๊ด`,
	str_12_8740: `โตว จินหัว`,
	str_12_8820: `มีความสุขในการตกปลา`,
	str_12_8730: `กระโดดประตูมังกร`,
	str_12_8810: `สงครามคาสิโน`,
	str_12_8700: `100 มือ Texas Hold'em`,
	str_12_8720: `หลายร้อยคนยิงโครงสำหรับตั้งสิ่งของ`,
	str_8_3001: `บาคาร่า`,
	str_8_3003: `ศึกมังกรกับเสือ`,
	str_8_3005: `ซังกง`,
	str_8_3006: `เวินโจว ปาย โกว`,
	str_8_3007: `รูเล็ต`,
	str_8_3008: `ซิกโบ`,
	str_8_3011: `แผ่นดิสก์สี`,
	str_8_3012: `นิว นิว`,
	str_8_3015: `ฟานทัน`,
	str_8_3016: `ปลา กุ้ง และปู`,
	str_8_3017: `ประกันบาคาร่า`,
	str_8_3018: `ดอกไม้สีทองทอด`,
	str_8_3021: `ไฮโล`,
	str_8_3025: `บาคาร่าบล็อคเชน`,
	str_8_3026: `บล็อกเชนมังกรและเสือต่อสู้`,
	str_8_3027: `Blockchain ประกันภัยบาคาร่า`,
	str_8_3028: `บล็อคเชนรูเล็ต`,
	str_8_3029: `ดอกไม้สีทองทอดบล็อคเชน`,
	str_8_3030: `Blockchain สามสาธารณะ`,
	str_8_3031: `บล็อกเชนกระทิง`,
	str_8_3032: `ดิสก์สีบล็อคเชน`,
	str_8_3033: `บล็อคเชนไฮโล`,
	str_8_3034: `บล็อคเชนปลา กุ้งและปู`,
	str_8_3036: `BlockchainHiLo`,
	str_8_3037: `Blockchain แฟนตาล`,
	str_8_3038: `Blockchain เหวินโจว ปาย โกว`,
	str_8_3039: `Blockchain ปลาเวียดนามกุ้งและปู`,
	str_8_3043: `Blockchain แบล็คแจ็ค บาคาร่า`,
	str_8_3045: `บล็อกเชน ปลาไทย กุ้งและปู`,
	str_8_3047: `แบล็คแจ็ค บาคาร่า`,
	str_8_109001: `ฟุตบอล`,
	str_8_109002: `บาสเกตบอล`,
	str_8_109003: `อเมริกันฟุตบอล`,
	str_8_109004: `เทนนิส`,
	str_8_109005: `เบสบอล`,
	str_8_109006: `ฮอคกี้น้ำแข็ง`,
	str_8_109007: `วอลเลย์บอล`,
	str_8_109008: `อีสปอร์ต`,
	str_8_109009: `แบดมินตัน`,
	str_8_109010: `บิลเลียด/สนุกเกอร์`,
	str_8_109012: `ศิลปะการต่อสู้แบบผสมผสาน`,
	str_8_109013: `เทเบิลเทนนิส`,
	str_8_109014: `รักบี้`,
	str_8_109017: `แฮนด์บอล`,
	str_8_109018: `ฮอกกี้สนามหญ้า`,
	str_8_109019: `แข่งรถ`,
	str_8_109020: `กอล์ฟ`,
	str_8_109023: `ลูกดอก`,
	str_8_109025: `โปโลน้ำ`,
	str_8_109029: `คริกเก็ต`,
	str_8_109040: `เน็ตบอล`,
	str_8_109051: `วอลเลย์บอลชายหาด`,
	str_8_109065: `ฟุตบอลชายหาด`,
	str_8_109082: `cs ไป`,
	str_8_109083: `Dota 2`,
	str_8_109084: `ลีกแห่งตำนาน`,
	str_8_109132: `ฟุตบอลอีสปอร์ต`,
	str_8_109133: `บาสเก็ตบอลอีสปอร์ต`,
	str_8_109147: `ราชาแห่งความรุ่งโรจน์`,
	str_8_109159: `เทนนิสอีสปอร์ต`,
	str_8_109160: `eSports ฮ็อกกี้น้ำแข็ง`,
	str_8_109161: `วอลเลย์บอลอีสปอร์ต`,
	str_8_109998: `ผสมผ่าน`,
	str_8_5005: `สตาร์ วอร์ส`,
	str_8_5006: `Staronic`,
	str_8_5008: `ลิงปีนต้นไม้`,
	str_8_5009: `คิงคองขึ้นบันได`,
	str_8_5010: `สงครามเอเลี่ยน`,
	str_8_5012: `พิชิตเอเลี่ยน`,
	str_8_5013: `ธรรมเนียม`,
	str_8_5014: `จังเกิ้ล`,
	str_8_5015: `ฟีฟ่า 2010`,
	str_8_5019: `สวรรค์ผลไม้`,
	str_8_5027: `มังกรกังฟู`,
	str_8_5030: `เทพเจ้าแห่งความโชคดี`,
	str_8_5039: `ปลา กุ้ง และปู`,
	str_8_5043: `ชามผลไม้เพชร`,
	str_8_5044: `สตาร์ 97II`,
	str_8_5045: `ลูกป่า`,
	str_8_5046: `จิตวิญญาณแห่งการต่อสู้`,
	str_8_5054: `แครปส์`,
	str_8_5057: `สตาร์ 97`,
	str_8_5058: `ชามผลไม้บ้า`,
	str_8_5061: `ซุปเปอร์7`,
	str_8_5062: `มังกรกำลังมา`,
	str_8_5063: `ผลไม้สล็อต`,
	str_8_5064: `โป๊กเกอร์ สล็อต`,
	str_8_5065: `筒子拉霸`,
	str_8_5066: `สล็อตฟุตบอล`,
	str_8_5067: `การเดินทางไปทางทิศตะวันตก`,
	str_8_5068: `คูลโซเซอร์คัส`,
	str_8_5069: `สนามกีฬาผลไม้`,
	str_8_5076: `วงล้อดิจิตอล`,
	str_8_5077: `วงล้อผลไม้`,
	str_8_5079: `3D วงล้อดิจิตอล`,
	str_8_5080: `ล้อล็อตโต้`,
	str_8_5083: `รถไฟเพชร`,
	str_8_5084: `ตำนานอสูรศักดิ์สิทธิ์`,
	str_8_5088: `ตู่ต้า`,
	str_8_5089: `หมาแดง`,
	str_8_5090: `การประกาศของไก่ทอง`,
	str_8_5093: `จิน ผิง เหม่ย`,
	str_8_5094: `จิน ผิง เหม่ย 2`,
	str_8_5095: `ไก่ชน`,
	str_8_5096: `ห้าองค์ประกอบ`,
	str_8_5097: `โลกใต้ท้องทะเล`,
	str_8_5098: `พรห้าประการมาถึงประตู`,
	str_8_5099: `แฮปปี้ โกลเด้น ด็อก`,
	str_8_5100: `ทานาบาตะ`,
	str_8_5105: `ยูโรเปี้ยนรูเล็ต`,
	str_8_5106: `สามประเทศ`,
	str_8_5107: `อเมริกันรูเล็ต`,
	str_8_5108: `รูเล็ตโบนัส`,
	str_8_5109: `รูเล็ตฝรั่งเศส`,
	str_8_5110: `เซี่ยงไฮ้กลางคืน`,
	str_8_5119: `เกาะลึกลับ`,
	str_8_5120: `นุว่าซ่อมฟ้า`,
	str_8_5121: `Olympus`,
	str_8_5122: `การต่อสู้ด้วยลูกบอล`,
	str_8_5123: `แบล็คแจ็คคลาสสิค`,
	str_8_5124: `สเปน 21 โมง`,
	str_8_5125: `เวกัส แบล็คแจ็ค`,
	str_8_5126: `โบนัส 21 แต้ม`,
	str_8_5127: `PUBG โมบายล์ 5128`,
	str_8_5128: `โชคลาภและความมั่งคั่งมากขึ้น`,
	str_8_5138: `ลูกปัดหมูคลิป`,
	str_8_5139: `แพนด้าพาราไดซ์`,
	str_8_5140: `เบียร์งานรื่นเริง`,
	str_8_5141: `ผู้ชนะการสู้วัวกระทิง`,
	str_8_5142: `แสงวิเศษและเสียงผี`,
	str_8_5143: `แคนดี้ ปาร์ตี้ 3`,
	str_8_5144: `คืนวาเลนไทน์`,
	str_8_5145: `ทีละขั้นเป็นขั้นบันไดสูง`,
	str_8_5146: `แคนดี้ปาร์ตี้`,
	str_8_5150: `อัญมณีในตำนาน`,
	str_8_5151: `Jenga`,
	str_8_5152: `ตำนานของอียิปต์`,
	str_8_5153: `จิ้งจอกเก้าหาง`,
	str_8_5154: `ฮัทสึเนะ แอตแทค`,
	str_8_5155: `พระราชวังมังกรทะเลจีนตะวันออก`,
	str_8_5156: `อาณาจักรซูม่า`,
	str_8_5157: `สามหยวนสี่ความสุข`,
	str_8_5159: `แมดแม็กซ์`,
	str_8_5160: `ธอร์ Thor`,
	str_8_5162: `ไข่แห่งความสุข`,
	str_8_5163: `หมาป่าพระจันทร์`,
	str_8_5164: `ของดีมาเป็นคู่`,
	str_8_5165: `เทพเจ้าแห่งสงคราม`,
	str_8_5166: `ลูกมะระ`,
	str_8_5167: `ม้าสู่ความสำเร็จ`,
	str_8_5168: `จดหมายข่าวไก่ทอง 2020`,
	str_8_5169: `เสียงภาษาจีน`,
	str_8_5170: `ตำนานใต้ท้องทะเล`,
	str_8_5171: `แคนดี้ปาร์ตี้ _ สปีด อิดิชั่น`,
	str_8_5172: `เทพเจ้าแห่งความมั่งคั่งบางส่วน`,
	str_8_5173: `โชคลาภ`,
	str_8_5174: `ราชาแห่งดนตรีอิเล็กทรอนิกส์`,
	str_8_5175: `ยิปโซฟิล่า`,
	str_8_5176: `รัฐสงครามอนารยชน`,
	str_8_5177: `ดอกบัว`,
	str_8_5178: `อาณาจักรไอน้ำ`,
	str_8_5181: `หลี่หลี่`,
	str_8_5182: `Douyin ดีเจ`,
	str_8_5183: `Reverse Qian Kun`,
	str_8_5184: `กระโดดประตูมังกร`,
	str_8_5185: `การเก็บเกี่ยวที่ดี`,
	str_8_5186: `ประกาศโชคลาภทั้งเจ็ด`,
	str_8_5187: `นินจามาสเตอร์`,
	str_8_5188: `สวัสดีปีใหม่ค่ะ`,
	str_8_5189: `โชควัว`,
	str_8_5191: `เต็มไปด้วยหมู`,
	str_8_5192: `โลกน้ำแข็ง`,
	str_8_5193: `ลูกอมบาร์`,
	str_8_5194: `เทพเจ้าทองคำแห่งความมั่งคั่ง`,
	str_8_5195: `ผึ้งชนะอย่างดุเดือด`,
	str_8_5197: `ปาร์ตี้มอนสเตอร์`,
	str_8_5198: `ตำนานฮาลอง`,
	str_8_5199: `อาหารข้างทาง`,
	str_8_5200: `ปลา กุ้ง ปู เปิดแล้วจ้า`,
	str_8_5204: `ฟีฟ่า 2014`,
	str_8_5205: `ที่จอดระเบิด`,
	str_8_5206: `หน้าไม้เต่าทองคำ`,
	str_8_5207: `อู๋ซอน ตีเสือ`,
	str_8_5208: `การแข่งขันบิงโก`,
	str_8_5209: `แพรรี่ แพท`,
	str_8_5210: `Candy Fun`,
	str_8_5211: `doofo เทพเจ้าแห่งความมั่งคั่ง`,
	str_8_5212: `เนจา`,
	str_8_5214: `ฟรุ้ตนินจา`,
	str_8_5215: `เล่นกันคืนนี้`,
	str_8_5216: `สมบัตินางเงือก`,
	str_8_5217: `ฟรุ๊ต ลัคกี้ สตาร์`,
	str_8_5218: `การผจญภัยในป่า`,
	str_8_5402: `ชีวิตตลาดกลางคืน`,
	str_8_5404: `วอลเลย์บอลชายหาด`,
	str_8_5407: `หนูน้อยหมวกแดงกับหมาป่าน้อย`,
	str_8_5601: `การผจญภัยที่ไม่จดที่แผนที่`,
	str_8_5803: `แอซเท็กเทรเชอร์`,
	str_8_5805: `ซีซาร์เอ็มไพร์ 5810`,
	str_8_5810: `อายุของการนำทาง`,
	str_8_5823: `ให้โชคลาภ`,
	str_8_5824: `ตำนานมังกรชั่วร้าย`,
	str_8_5828: `ไทแรนโนซอรัส เร็กซ์`,
	str_8_5835: `สวัสดีปีวัว`,
	str_8_5837: `สวัสดีปีลิง`,
	str_8_5839: `คลาสสิคไฮบอล 5901`,
	str_8_5901: `ล่าขุมทรัพย์ต่อเนื่อง`,
	str_8_5902: `แคนดี้ปาร์ตี้`,
	str_8_5903: `สมบัติลับของจักรพรรดิฉิน 5904`,
	str_8_5904: `ระเบิดไอน้ำ 5908`,
	str_8_5908: `แคนดี้ปาร์ตี้ 2`,
	str_8_5909: `มีความสุข Xiao Xiaole`,
	str_8_5910: `ธาตุวิเศษ`,
	str_8_5912: `Serial Treasure 2`,
	str_8_5888: `แจ็คพอต`,
	str_8_30599: `ผู้เชี่ยวชาญด้านการตกปลา`,
	str_8_30598: `ผู้เชี่ยวชาญด้านการตกปลา 2`,
	str_8_30593: `ตกปลาชายทอง`,
	str_8_38001: `ปรมาจารย์ตกปลา`,
	str_8_38002: `ฟาร์มปลาที่อุดมสมบูรณ์`,
	str_3_kxyznmbpret1y: `ป่าหลงเสน่ห์`,
	str_3_qd1fcneqbhgy4: `Hentai`,
	str_3_kdn8ckjqfhsn4: `หลุมฝังศพของฟาโรห์`,
	str_3_d4fyes4amfxf6: `ฟีนิกซ์`,
	str_3_a7q65cfts455e: `มวย2`,
	str_3_cuarr8e1ncebn: `ผลไม้เมืองร้อน`,
	str_3_96k1k6d3x39za: `การผจญภัยในป่า`,
	str_3_x5ikj69a989x6: `นักล่าทอง`,
	str_3_c85wq8o9doqtr: `พ่อมด`,
	str_3_hb4cpgc6u6qj4: `เทพปกรณัมตะวันตก`,
	str_3_wr5axzs95uq7r: `สมบัติของป่า`,
	str_3_cd4rcge6dhqb4: `วันแห่งความตาย`,
	str_3_exesnxb7ge3uy: `บ้านผีสิง`,
	str_3_pd6rhresnhkbk: `เส้าหลิน`,
	str_3_ezjsgctugyauc: `บิ๊กฟอร์จูนบิงโก`,
	str_3_fn6yhwksk7kfk: `พริกฮันเตอร์บิงโก`,
	str_3_nqyun5dpcjtsy: `การแข่งขันออนไลน์`,
	str_3_uafejs6a58xp6: `นักล่าเงินรางวัล`,
	str_3_jzpssktmfyw1h: `สิบสองกลุ่มดาว`,
	str_3_7b6c7rcs16kjk: `สเปรย์น้ำมหาสมุทร`,
	str_3_uwf5zss55dc7h: `เย่เซียน`,
	str_3_3fx69pizs144w: `สตรีคนำโชค`,
	str_3_6o5emdcnoqyen: `วัดแอซเท็ก`,
	str_3_5cx47jffukp3o: `แปดสมบัติกระเป๋า`,
	str_3_gqotnunpejbwy: `เทศกาลแห่งโชคลาภ`,
	str_3_b1cnw7mkppwg1: `นักฆ่า`,
	str_3_6c5apdrpokbay: `เทพเจ้าแห่งความมั่งคั่งเจริญรุ่งเรือง`,
	str_3_ipz77igi3mfho: `ฤดูหนาวที่แสนหวาน`,
	str_3_b5ggg45epfzg6: `ซุปเปอร์แพลนเน็ต`,
	str_3_93ine65axf986: `มวย`,
	str_3_4eekxm7cistkg: `โดเมนของมังกร`,
	str_3_y5n8sh5oqf58q: `ถ้ำเสือ`,
	str_3_r8oiyz19mtqir: `ตัวตลกนำโชค`,
	str_3_ha1jzrho1gmjq: `อัญมณีมายัน`,
	str_3_3erm9p7wssiks: `ไฟแห่งโชคชะตา`,
	str_3_ofy9b9z99u69r: `อาณาจักรมังกร`,
	str_3_swt38osdadyhc: `โจรสลัดซากะ`,
	str_3_gkubyu4cjibrg: `ตัวตลกบ้า`,
	str_3_rqaonzn7kjjiy: `สี่สิ่งประดิษฐ์ที่ยิ่งใหญ่`,
	str_3_m94wkgy3daxta: `มิสติก แซนด์`,
	str_3_tocki7xk7xwq1: `ไฟร์เพิร์ลบิงโก`,
	str_3_cz3wgrounyetc: `อะควาแมนบิงโก`,
	str_3_z7k6mqf3z495a: `Crypto Mania บิงโก`,
	str_3_fqho1inijjfwo: `ราชามังกรทะเลจีนตะวันออก`,
	str_3_8kzbot4rew7ds: `การเดินทางไปทางทิศตะวันตก`,
	str_3_gsttgo1debywc: `พลอยแปดเหลี่ยม2`,
	str_3_quofrdenycyyn: `ซุบซิบ2`,
	str_3_1wt58azdhdo6c: `นางฟ้าทุกคู่`,
	str_3_n1ydr5mncpogn: `พริกฮันเตอร์`,
	str_3_gn1bc1kqj7gr4: `ซุบซิบ`,
	str_3_dxxsh3dfmjpio: `สูงเกินไป ลาว จุน`,
	str_3_9ii7s6u5xbhzh: `ต้นไม้โลก`,
	str_3_wcaadzg74mj7y: `เลดี้อีเกิ้ล`,
	str_3_s77hiogba5dhe: `พีช คลับ`,
	str_3_bzgza4umpbwsh: `ตำนานสามเจ้าชาย`,
	str_3_bmr8675wqiigs: `แม่มดน่ารัก`,
	str_3_oajk3h9o685xq: `โกดัง`,
	str_3_ur8593z8hu17w: `ไข่มุกเผา`,
	str_3_j9nzkkbjfaz1a: `ดวงตาแห่งฮอรัส`,
	str_3_1ru5x5zx7us6r: `เทพสายฟ้า`,
	str_3_5ii9zgw5unc3h: `สมบัติของอควาแมน`,
	str_3_wykepsq659qp4: `มังกรสี่ตัว`,
	str_3_q9gi4yybyadoe: `แพนด้าป่า`,
	str_3_dkzdo35rcipfs: `ประเทศจีน`,
	str_3_ie9eti6w4zfcs: `สิ่งประดิษฐ์โบราณ`,
	str_3_7cz37fritkfao: `ไก่นำโชค`,
	str_3_84igeq3a8r9d6: `นักเก็ตฮันเตอร์`,
	str_3_4tyxfmpnwqokn: `พลอยแปดเหลี่ยม`,
	str_3_soojfuqnaxycn: `หน้าร้อนของผลไม้`,
	str_3_rsjogw1ukbeic: `เสือสี่ตัวแห่งเอเชีย`,
	str_3_3yfmucpss64mk: `เปลวไฟมังกร`,
	str_3_o7f9ih8t6559e: `อู๋ เจ๋อเทียน`,
	str_3_wtupmzq14xepn: `เชิดสิงโต`,
	str_3_d8cso3u8ct1iw: `ฟีนิกซ์กลับชาติมาเกิด 888`,
	str_3_7tccifcktqre1: `ผู้ประกอบการรายใหญ่`,
	str_3_4akkze7ywgukq: `การเข้ารหัสลับความบ้าคลั่ง`,
	str_3_86burqb38a9ua: `บูชิโด`,
	str_3_8u9r4tj48chd1: `ราชาระเบิด`,
	str_3_zygj7oqga9nck: `เทพเจ้าแห่งโชคลาภ`,
	str_3_srd3xusx3ughr: `เข้า KTV`,
	str_3_5ypkuepgw61kk: `ห้าธาตุน้ำส่งพร`,
	str_3_yxdzc9d7qj3zy: `ธาตุไฟห้าธาตุส่งพร`,
	str_3_g8awyu1xjtgwr: `ไฟแดงคริติคอล`,
	str_3_e4ndsc3ogr5dq: `เฟลมดราก้อน 88`,
	str_3_m1xn4je4dccb1: `อัญมณีโบราณ`,
	str_3_qn3ynneqbhgy4: `เสือสามตัวครอง`,
	str_3_kqm1cmbpret1y: `เครื่องประดับตัวตลก`,
	str_3_knjnnkjqfhsn4: `ตำนานมังกร 888`,
	str_3_d5qfgs4amfxf6: `ปั่นบ้า`,
	str_3_ahf5icfts455e: `ลัคกี้ จินฟู`,
	str_3_c41bsraonrmbq: `ซวนปู กาล่า`,
	str_3_99bzr6d3x39za: `คุณสังกัดอะไร`,
	str_3_x46x869a989x6: `เทพเจ้าแห่งโชคลาภ`,
	str_3_kk8nqm3cfwtng: `ไฮบา`,
	str_3_xkhy6baryz7xs: `Aquaman 2 อดีต _ มือใหม่`,
	str_3_qq5ocdypyeboy: `Aquaman 2 อดีต _ ผู้เริ่มต้น`,
	str_3_g54rso4yefdrq: `Aquaman 2 อดีต _ ผู้เชี่ยวชาญ`,
	str_3_ary5bxi9z165r: `Aquaman 2 อดีต _ เพื่อน`,
	str_3_b8rzo7uzqt4sw: `ปลาทองคางคก`,
	str_3_8d7r1okge7nrk: `ต้าเซิง นาวไห่`,
	str_3_nzkseaudcbosc: `หลี่กุยแยกปลา`,
	str_3_wi17jwsu4de7c: `วัวเงินสด`,
	str_3_1jeqx59c7ztqg: `อะควาแมน 3`,
	str_3_4omkmmpnwqokn: `สพันจ์บ็อบ สแควร์แพนท์`,
	str_3_st5cmuqnaxycn: `มีความสุขในการตกปลา5`,
	str_3_ddpg1amgc71gk: `บักพาราไดซ์`,
	str_3_p63ornyjba8oa: `ท่าเทียบเรือของชาวประมง`,
	str_3_xq9ohbyf9m79o: `ราชานกต่อสู้เพื่อกระรอกบินและท้องฟ้าหลวง`,
	str_3_hcu3p8r71kj3y: `ซุปเปอร์สตาร์`,
	str_3_hf5hx8w9u1q3r: `หนังสือพันธสัญญา Deluxe Edition`,
	str_3_43bx3e7ywgukq: `Dolphin's Pearl รุ่นดีลักซ์`,
	str_3_ateqfxp1sqamn: `สมบัติปลาโลมา`,
	str_3_fk9yoi4wkifrs: `50 โกลเด้น ไลออน`,
	str_3_ww3a8wsu4de7c: `ผลไม้ฤดูร้อน`,
	str_3_8nsbhokge7nrk: `ราชินีแห่งแม่น้ำไนล์`,
	str_3_qxoindypyeboy: `เกอิชา`,
	str_3_xmzfobaryz7xs: `ราชาแห่งท้องทะเล`,
	str_3_7f9h9fwz11kaw: `เครื่องรางนำโชค รุ่นดีลักซ์`,
	str_3_ioheiiqk3xrc1: `หนังสือพันธสัญญา`,
	str_3_k9gz4ebbrau1e: `มังกรทองคู่`,
	str_3_aij68ciusna5c: `โคลัมบัส`,
	str_3_satj3o6ya8dcq: `สุพรีมจิวเวลรี่`,
	str_3_5m6k9j7rwspjs: `โคลอสเซียม`,
	str_3_igg7tisz4ukhw: `คลีโอพัตรา`,
	str_3_w4ypzw6o48mpq: `มังกรและนกฟีนิกซ์`,
	str_3_xbxy1yegyhnyk: `ผจญภัยเกาะป่า`,
	str_3_foff4ikkjprr1: `ขอบน้ำ`,
	str_3_ef1uyxt98o6ur: `เทพเจ้าแห่งโชคลาภ`,
	str_3_naagsa5ycfugq: `อียิปต์โบราณ`,
	str_3_i4rc816e388c6: `โรบินฮู้ด`,
	str_3_nh9swadbc3use: `ความเร็วสูง Crown Link`,
	str_3_tqi9778i7mi6o: `ไมอามี่`,
	str_3_byz81hmsq748k: `เทพเจ้าแห่งความมั่งคั่งสูงสุด`,
	str_3_ruufkzk1kpefn: `การเชื่อมต่อกระสุนเงิน`,
	str_3_awn5jciusna5c: `โจรกัปตัน Connect`,
	str_3_3hj4fkfji4z4a: `เทพเจ้าแห่งโชคลาภ Fafafa 2`,
	str_3_u17q53q45xcp1: `ตำนานงูขาว`,
	str_3_kia1eetdryo1c: `อลิซ`,
	str_3_9xpa7brfxj7zo: `Mamma Mia`,
	str_3_pirtanombyroh: `โลกป่าเถื่อน`,
	str_3_ne4gq55cpitgg: `ถั่ววิเศษ`,
	str_3_k3anse3yrrunq: `นายอำเภอตะวันตก`,
	str_3_79mafnrjt48aa: `ผาน จินเหลียน`,
	str_3_fwria11mjbrwh: `อำนาจสามก๊ก`,
	str_3_dc7sh3dfmjpio: `เสือมังกร`,
	str_3_3uim5ppkiqwk1: `ปลา กุ้ง และปู`,
	str_3_j3wngk3efrzn6: `บาคาร่า`,
	str_3_yr1zy9u9xt6zr: `น้ำเต้า`,
	str_3_hxb3p8r71kj3y: `ซิกโบ`,
	str_3_8rqwot18etnuw: `ธอร์`,
	str_3_9upe5bm4xph81: `ราชาลิง`,
	str_3_113qm5xnhxoqn: `ตะเกียงอะลาดิน`,
	str_3_ywozehuuqbazc: `เกาะทอง`,
	str_3_bcizh7dipjiso: `หัวมู่หลาน`,
	str_3_55hj8ghaugxj6: `สมายล์ ไมตรียะ`,
	str_3_jpiuhpbifei1o: `การประกาศของไก่ทอง`,
	str_3_itzp5iqk3xrc1: `วิญญาณป่า`,
	str_3_7rw3tfwz11kaw: `สมบัติอาร์กติก`,
	str_3_aodmmxp1sqamn: `โชคลาภ`,
	str_3_o3nxzh9o685xq: `มังกรบินบนฟ้า`,
	str_3_ufc6t3z8hu17w: `เซอร์ไพรส์คริสต์มาส`,
	str_3_j6j1rkbjfaz1a: `ห้าเสือแม่ทัพ`,
	str_3_9w6aa6u5xbhzh: `ขนมังกรทอง`,
	str_3_wpu7pzg74mj7y: `กลองมงคลเสริมโชคลาภ`,
	str_3_tbfxuhxs694xk: `ฟอร์จูนแพนด้า`,
	str_3_gd3rn1kqj7gr4: `ราชินี`,
	str_3_wfo7bzs95uq7r: `อาร์เชอร์`,
	str_3_jsguaktmfyw1h: `เฮอร์คิวลิส`,
	str_3_dhdirsn3m3xia: `เทพเจ้าแห่งโชคลาภมาถึง`,
	str_3_kf41ymtxfos1r: `พิพิธภัณฑ์สัตว์น้ำ`,
	str_3_ebudnqj68h6d4: `เทศกาลแห่งความสุข`,
	str_3_9mqe9bhroi78s: `ราชามังกี้ทองคำ`,
	str_3_4d5kdkpqi6sk4: `การผจญภัยกระหายเลือด`,
	str_3_5864tji8w113w: `แบบไทยๆ`,
	str_3_1q36p58phmt6y: `อะลาดิน`,
	str_3_xtpy4bx49xhx1: `สำรวจแอฟริกา`,
	str_3_69xaiyrbo4dae: `คาร์นิวัล ไนท์`,
	str_3_z1pc5tp4zqhm1: `กระสุนเงิน`,
	str_3_bes8675wqiigs: `กัปตันเทรเชอร์`,
	str_3_bwwza4umpbwsh: `แดนซ์ออฟเดอะแบร์`,
	str_3_qieoeyodyyyoc: `กัปตันเทรเชอร์ Enhanced Edition`,
	str_3_rh8iwwntk3mie: `โลกปลาโลมา`,
	str_3_axt5pxf7sk35y: `มงกุฎแห่งความเร็ว`,
	str_3_jbzd1cjsgh4dk: `สปาร์ตา`,
	str_3_oqt9p9876m39y: `แอซเท็กพีระมิด`,
	str_3_t656f48j75z6a: `มหาสมุทรสีฟ้าที่ยิ่งใหญ่`,
	str_3_s6xhiogba5dhe: `ฟุตบอล`,
	str_11_102614: `ฟาฟาฟา2`,
	str_11_102617: `จีจี้จี`,
	str_11_102618: `เทพธิดาเซ็กซี่`,
	str_11_102619: `ราชาสิงโตขาว`,
	str_11_102623: `Monkey King`,
	str_11_102612: `ปาร์ตี้โป๊กเกอร์`,
	str_11_102620: `ราชาแห่งความเร็วสูง`,
	str_11_10211: `รวยกัปตัน`,
	str_11_10212: `ทะเลผี`,
	str_11_10213: `เจ้าพ่อยาเสพติดทะเลาะวิวาท`,
	str_11_802101: `หัวใจของมหาสมุทร`,
	str_11_102621: `สมบัติของกัปตัน`,
	str_11_102620: `ราชาแห่งความเร็วสูง`,
	str_11_802601: `ระเบิดรางวัล777`,
	str_11_102612: `ปาร์ตี้โป๊กเกอร์`,
	str_11_20264: `แม่บ้าน`,
	str_11_802604: `ฆ่าซอมบี้`,
	str_11_802606: `ยูโร 2021`,
	str_11_202613: `กล้วยใหญ่`,
	str_11_202611: `ปีศาจจิ้งจอก`,
	str_11_102615: `ราชินีใต้`,
	str_11_102616: `ตำนานอียิปต์`,
	str_11_10264: `ฟ้าร้องและฟ้าผ่าผนึกพระเจ้า`,
	str_11_702619: `สวรรค์บ้า`,
	str_13_7_7001: `ตกปลาราชามังกร`,
	str_13_7_7002: `ตกปลาราชามังกร2`,
	str_13_7_7003: `เทพเจ้าแห่งโชคลาภตกปลา`,
	str_13_7_7004: `การตกปลามังกรห้าตัว`,
	str_13_7_7005: `ตกปลาตลอดทาง`,
	str_13_7_7006: `นักล่ามังกร`,
	str_13_7_7007: `ดิสโก้ตกปลา`,
	str_13_0_8001: `มังกรนำโชค`,
	str_13_0_8002: `น้ำหอมกลิ่นฤดูใบไม้ร่วงของ Tang Bohu`,
	str_13_0_8003: `เปลี่ยนใบหน้า`,
	str_13_0_8004: `โกคู`,
	str_13_0_8005: `ลามะ แอดเวนเจอร์`,
	str_13_0_8006: `หมีดำไต้หวัน`,
	str_13_0_8007: `ลัคกี้ หลิน`,
	str_13_0_8014: `สิงโตนำโชค`,
	str_13_0_8015: `สมบัติแสงจันทร์`,
	str_13_0_8016: `แรปโซดีพนักงานออฟฟิศ`,
	str_13_0_8017: `ปีใหม่`,
	str_13_0_8018: `นโปเลียน`,
	str_13_0_8019: `สมบัติทั้งสี่ของการศึกษา`,
	str_13_0_8020: `เปิดงา`,
	str_13_0_8021: `อาณาจักรกล้วยทอง`,
	str_13_0_8022: `นักรบนกกระจอก`,
	str_13_0_8023: `วิหารแห่งโอลิมเปีย`,
	str_13_0_8024: `อาณาจักรคริสตัล`,
	str_13_0_8025: `ขโมย`,
	str_13_0_8026: `เจ้าพ่อเต้นร้อนแรง`,
	str_13_0_8027: `เชฟคิง`,
	str_13_0_8028: `นำโชคหนูทอง`,
	str_13_0_8029: `แฟนตาซีแคนดี้ไอส์แลนด์`,
	str_13_0_8030: `นักวิทยาศาสตร์บ้า`,
	str_13_0_8031: `เกี๊ยวทอง`,
	str_13_0_8034: `คนเงิน`,
	str_13_0_8035: `ลัคกี้ฟีนิกซ์`,
	str_13_0_8036: `ราชามังกร`,
	str_13_0_8037: `การแสดงมายากล`,
	str_13_0_8044: `ความงามของประเทศ`,
	str_13_0_8046: `กวนอู`,
	str_13_0_8047: `ใบหน้าเปลี่ยน2`,
	str_13_0_8048: `เปิดงา2`,
	str_13_0_8049: `น้ำหอมกลิ่นฤดูใบไม้ร่วงของ Tang Bohu2`,
	str_13_0_8050: `ได้เงินเร็วๆนี้`,
	str_13_0_15001: `การประกาศของไก่ทอง`,
	str_13_0_15002: `ราชาลิง`,
	str_13_0_15004: `อาร์เรย์ไฟกระทิง`,
	str_13_0_15005: `ลัคกี้ ฟูวา`,
	str_13_0_15006: `อาณาจักรอินคา`,
	str_13_0_15009: `นินจาจู่โจม`,
	str_13_0_15010: `เชฟแพนด้า`,
	str_13_0_15011: `ตำนานโฮ่วอี้`,
	str_13_0_15012: `พรห้าประการมาถึงประตู`,
	str_13_0_15013: `จิ้งจอกเก้าหาง`,
	str_13_0_14001: `ไก่ชน`,
	str_13_0_14002: `การผจญภัยของชาวมายัน`,
	str_13_0_14003: `Diaosi Panda`,
	str_13_0_14004: `ตำนานแห่งเซลด้า`,
	str_13_0_14005: `กระเป๋าผู้ใหญ่`,
	str_13_0_14006: `มหาเศรษฐี`,
	str_13_0_14007: `วันพันช์แมน`,
	str_13_0_14008: `นักรบมังกร`,
	str_13_0_14010: `มังกรบินบนฟ้า`,
	str_13_0_14011: `ผู้ปกครองของกาแล็กซี่`,
	str_13_0_14012: `นักสู้ข้างถนน`,
	str_13_0_14013: `นักสู้ข้างถนน`,
	str_13_0_14015: `สตาร์วอร์ส`,
	str_13_0_14016: `ตัวแทนเอซ`,
	str_13_0_14017: `แนวหน้าหญิง`,
	str_13_0_14018: `Daji`,
	str_13_0_14019: `อัญมณี สตอรี่`,
	str_13_0_14020: `เทพเจ้าน้ำนมมหัศจรรย์`,
	str_13_0_14021: `เงินม้วน เงิน`,
	str_13_0_14022: `ผู้ประกอบการเหมืองแร่`,
	str_13_0_14023: `คิงออฟโปกเกอร์`,
	str_13_0_14025: `ลัคกี้ เรซซิ่ง`,
	str_13_0_14026: `สร้างรายได้`,
	str_13_0_14027: `ขอให้โชคดี 777`,
	str_13_0_14029: `สัตว์ร้ายตะวันออก`,
	str_13_0_14030: `ทริปเปิ้ลคิงคอง`,
	str_13_0_14033: `ปาร์ตี้นกบิน`,
	str_13_0_14034: `โกวไหลฟู`,
	str_13_0_14035: `รำมังกร`,
	str_13_0_14036: `ซุปเปอร์คาว บี`,
	str_13_0_14038: `สมบัติอียิปต์`,
	str_13_0_14039: `โชคดีและสมบัติ`,
	str_13_0_14040: `ขุมทรัพย์เซเว่นซี`,
	str_13_0_14041: `ค้อนของธอร์`,
	str_13_0_14042: `ชามสมบัติ`,
	str_13_0_14043: `เต้นรำ`,
	str_13_0_14044: `Odd King Kong`,
	str_13_0_14045: `Super Cow B Deluxe Edition`,
	str_13_0_14046: `ขุดที่รัก`,
	str_13_0_14047: `ผู้ประกอบการ`,
	str_13_0_14048: `เสือมังกร เสือป่า`,
	str_13_0_14049: `ผลไม้ระเบิด`,
	str_13_0_14050: `คลื่น`,
	str_13_0_14051: `เล่ย เยว่ หลงเหมิน`,
	str_13_0_14052: `สมบัติของป่า`,
	str_13_0_14053: `คลื่น2`,
	str_13_0_14054: `สว่านซุปเปอร์`,
	str_13_0_14055: `คิงคอง`,
	str_13_0_14056: `พี่น้องไทแรนโนซอรัส`,
	str_13_0_14057: `นินจาเอ็กซ์`,
	str_13_0_14058: `ฟลายอิ้ง ช้าง ฟอร์จูน`,
	str_13_0_14059: `Super IV`,
	str_13_0_14060: `โคมนำโชค`,
	str_13_0_14061: `มายา คิม เครซี่`,
	str_13_0_14062: `สงครามจักรวรรดิ`,
	str_13_0_14063: `ไตรภาคใหญ่`,
	str_13_0_14064: `ปาร์ตี้ระเบิด`,
	str_13_0_14065: `ดอกไม้ที่อุดมสมบูรณ์`,
	str_13_0_14066: `สตาร์ แอร์ไลน์`,
	str_13_0_14067: `ขาว รวย สวย`,
	str_4_ermj: `ไพ่นกกระจอกสำหรับสองคน`,
	str_4_blackjack: `21 นาฬิกา`,
	str_4_sangong: `ซังกง`,
	str_4_qydz: `ออลอินเท็กซัส`,
	str_4_zjh: `ดอกไม้สีทองทอด`,
	str_4_blnn: `นิว นิว`,
	str_4_baccarat: `บาคาร่า`,
	str_4_tbnn: `Tumblr นิวนิว`,
	str_4_hbmj: `การ์ดห้าดาว`,
	str_4_dzmj: `ไพ่นกกระจอกยอดนิยม`,
	str_4_gdmj: `ไพ่นกกระจอกกวางตุ้ง`,
	str_4_hnmj: `หูหนานไพ่นกกระจอก`,
	str_4_rbwar: `สงครามสีแดงและสีดำ`,
	str_4_hzmj: `หางโจวไพ่นกกระจอก`,
	str_4_mjxzdd: `การต่อสู้นองเลือด`,
	str_4_mjxlch: `แม่น้ำเลือด`,
	str_4_gyzjmj: `กุ้ยหยางจับไก่`,
	str_14_1001: `Haibawang`,
	str_14_1002: `กินฉันหนึ่งนัด`,
	str_14_1003: `ตกปลาซานเซียน`,
	str_14_1004: `นักล่ามังกร`,
	str_14_1006: `รวยได้ด้วยค้อนก้อนเดียว`,
	str_14_1007: `พืช vs ไดโนเสาร์`,
	str_14_1009: `ปลาแยกสามอมตะ`,
	str_14_2001: `เสือมังกรทอง`,
	str_14_2002: `วัวร้อยคน`,
	str_14_2003: `สวัสดีเงินทอดดอกไม้ทอง`,
	str_14_2004: `28 แท่ง`,
	str_14_2006: `บาคาร่า`,
	str_14_2005: `ซังกง`,
	str_14_2007: `น้ำสิบสาม`,
	str_14_2008: `กระบอง`,
	str_14_2009: `เท็กซัส โฮลเอ็ม`,
	str_14_2010: `หยิบซองแดง`,
	str_14_2011: `หยิบ Zhuang Niu Niu`,
	str_14_3001: `ผู้ประกอบการเพชร`,
	str_14_3002: `กระโจนประตูมังกร`,
	str_14_3003: `ส่งมาเลย`,
	str_14_3004: `สิงโตครองโลก`,
	str_14_3005: `สมบัติลับใหญ่`,
	str_14_3006: `ออราเคิลอียิปต์`,
	str_14_3007: `เทพเจ้าแห่งโชคลาภมาถึง`,
	str_14_3008: `ราชวงศ์ถังที่ยิ่งใหญ่`,
	str_14_3009: `ฟอร์จูนไลออน`,
	str_14_3010: `ลิงปราชญ์ใหญ่`,
	str_14_3011: `ปล้นห้องนิรภัย`,
	str_14_3012: `สัตว์ศักดิ์สิทธิ์ทั้งห้า`,
	str_14_3013: `มีความสุข`,
	str_14_3014: `อาหรับ`,
	str_14_3015: `ตำนานหมาป่าผู้หิวโหย`,
	str_14_3016: `คริสตัลผลไม้`,
	str_14_3017: `กอล์ฟ`,
	str_14_3018: `ไทเกอร์คิง`,
	str_14_3019: `พระเจ้า zeus`,
	str_14_3020: `แดร็กคิวล่า`,
	str_14_3021: `ราชาโจรสลัด`,
	str_14_3022: `อลิซ`,
	str_14_3023: `โฮมินิดส์`,
	str_14_3024: `เลย์บาลอง`,
	str_14_3025: `ราชาแห่งคณะละครสัตว์`,
	str_14_3026: `เปลี่ยนหินเป็นทอง`,
	str_14_3027: `มายา คิง`,
	str_14_3028: `ฟรุตบาร์`,
	str_14_3029: `ฟอร์จูน ดราก้อน`,
	str_14_3030: `เจ้าลิงทอง`,
	str_14_3031: `พระเจ้าเสด็จมา`,
	str_14_3032: `มนุษย์หมีแพนด้า`,
	str_14_3033: `ส่งทันที`,
	str_14_3034: `777`,
	str_14_3035: `ลิงสามตัว`,
	str_14_3036: `จ้าวหยุนหวู่ซวง`,
	str_14_3037: `ฟีนิกซ์เพลิง`,
	str_14_3038: `ลู่ จี วู่ซวง`,
	str_14_3039: `เป่า ยูฟา`,
	str_14_3040: `สาวๆหลายคน`,
	str_14_3041: `ผู้หญิงมากขึ้น`,
	str_14_3042: `เทพเจ้าแห่งความร่ำรวย`,
	str_14_3043: `ให้เหรียญทองแมว`,
	str_14_3044: `Người bất tử bay`,
	str_14_3045: `หนูเงิน`,
	str_14_3046: `กุ๊กน้อย`,
	str_14_3047: `โพคาริ`,
	str_14_3048: `บิงกัวบะ`,
	str_14_3049: `ตาสีทอง`,
	str_14_3050: `ระเบิดไก่`,
	str_14_3051: `ตระกูลน้ำหอมผัก`,
	str_14_3052: `จักรวรรดิโรมัน`,
	str_14_3054: `กำปั้นครอบงำ`,
	str_14_3055: `ราชวงศ์อียิปต์`,
	str_14_3056: `สมบัติมังกรวิเศษ`,
	str_14_3057: `คุณจะหลอก`,
	str_14_3058: `ซองจดหมายสีแดง`,
	str_14_3059: `วิ่งกระทิง`,
	str_14_4001: `เกมบันได`,
	str_14_4002: `ยิงโครงสำหรับตั้งสิ่งของ`,
	str_14_4003: `ไข่ตื่นทอง`,
	str_14_4009: `พร้อมที่จะไป`,
	str_15_2: `ไพ่นกกระจอกสำหรับสองคน`,
	str_15_3: `หยิบ Zhuang Niu Niu`,
	str_15_4: `วัวร้อยคน`,
	str_15_5: `ตกปลาราชามังกร`,
	str_15_6: `เงินมากขึ้นและโชคลาภมากขึ้น`,
	str_15_7: `Jing Mi Chu Hand Dezhou`,
	str_15_8: `ตัวผลัก`,
	str_15_9: `เพิ่มเจ้าของบ้านเป็นสองเท่า`,
	str_15_10: `Insurance Chu Hand Texas`,
	str_15_11: `การต่อสู้นองเลือด`,
	str_15_12: `ดอกไม้สีทองทอด`,
	str_15_13: `ต้องไปเท็กซัส`,
	str_15_14: `หลายร้อยคน san gong`,
	str_15_15: `น้ำสิบสาม`,
	str_15_17: `ตกปลา 3 มิติ`,
	str_15_19: `มีความสุขโยก`,
	str_15_20: `Tumblr นิวนิว`,
	str_15_22: `บาคาร่า`,
	str_15_23: `28 แท่ง`,
	str_15_24: `มณฑลกวางตุ้งโค่นล้ม Hu`,
	str_15_25: `กระบอง`,
	str_15_26: `ไก่กวางตุ้ง ผิงหู`,
	str_15_33: `Lấy cổ điển Zhuang Niu Niu`,
	str_15_35: `ลูกป่า`,
	str_15_39: `วิ่งเร็ว`,
	str_15_42: `แม่น้ำเลือด`,
	str_15_44: `ศึกมังกรกับเสือ`,
	str_15_45: `NI UN IU ใหญ่ กินเล็ก`,
	str_15_47: `พลิกอย่างมีความสุข`,
	str_15_49: `Doudizhu เวอร์ชันใหม่`,
	str_15_51: `ปลา กุ้ง และปู`,
	str_15_52: `ดูภาพสี่ภาพเพื่อคว้า Zhuang Niuniu`,
	str_15_53: `ซานกงกินน้อย`,
	str_15_55: `ไพ่นกกระจอกไต้หวัน`,
	str_15_56: `ถ้วยผลไม้`,
	str_16_baccarat: `บาคาร่า`,
	str_16_dragontiger: `เสือมังกร`,
	str_16_topcard: `ห้องโถงฟุตบอล`,
	str_16_blackjack: `กระบอง`,
	str_16_scalableblackjack: `แบล็คแจ็คไม่อั้น`,
	str_16_roulette: `รูเล็ต`,
	str_16_americanroulette: `อเมริกันรูเล็ต`,
	str_16_instantroulette: `รูเล็ตเปิดเป็นครั้งคราว`,
	str_16_craps: `แครปส์`,
	str_16_moneywheel: `วงล้อแห่งโชคชะตา/วงล้อแห่งความฝัน`,
	str_16_sicbo: `ซุปเปอร์ซิกโบ`,
	str_101_100: 'GB ปลา',
	str_gamesneme_0: `ร้อน`,
	str_gamesneme_1: `ทั่วไป`,
	str_gamesneme_2: `เกม`,
	str_gamesneme_3: `อิเล็กตรอน`,
	str_gamesneme_4: `ภายในระบบ`,
	str_gamesneme_5: `ตกปลา`,
	str_gamesneme_6: `เล่นหมากรุก`,
	str_gamesneme_7: `เล่นเกม`,
	str_gamesneme_all: `ทั้งหมด`,

	str_ChannelsName_1: `GB`,
	str_ChannelsName_2: `WM`,
	str_ChannelsName_3: `JOKER`,
	str_ChannelsName_4: `博樂`,
	str_ChannelsName_5: `SBO`,
	str_ChannelsName_6: `CQ9`,
	str_ChannelsName_7: `ไคหยวน`,
	str_ChannelsName_8: `BBIN `,
	str_ChannelsName_9: `SEXY `,
	str_ChannelsName_10: `DG`,
	str_ChannelsName_11: `FUNKY`,
	str_ChannelsName_12: `เลอ ทัวร์`,
	str_ChannelsName_13: `JDB`,
	str_ChannelsName_14: `DS`,
	str_ChannelsName_15: `VG`,
	str_ChannelsName_16: `EVO`,
	str_ChannelsName_101: `GB`,
	str_balanceType_5: `โบนััสจากขึ้นระดับวีไอพี`,
	str_balanceType_6: `โบนัส `,
	str_balanceType_7: `การถอนเงิน`,
	str_balanceType_8: `ฝากยอด`,
	str_balanceType_9: `เปลี่ยนแปลงวงเงิน`,
	str_balanceType_10: `เครดิตเงินคืน `,
	str_balanceType_11: `เพิ่มยอดโดยพนักงาน`,
	str_balanceType_12: `โบนัสฝากยอด `,
	str_balanceType_13: `คืนยอดถอน`,
	str_balanceType_14: `กิจกรรมอั่งเปา`,
	str_balanceType_15: `ชิงโชค`,
	str_balanceType_16: `กิจกรรมผ่านด่าน`,
	str_balanceType_17: `ฝากยอดครั้งแรก`,
	str_balanceType_18: `ยกยอดคอมมิชชั่นเข้า`,
	str_info_title: `ข้อมูลส่วนตัว`,
	str_info_portrait: `รูปครึ่งตัว `,
	str_info_name: `ซื่อจริง`,
	str_info_phonenumber: `หมายเลขโทรศัพท์`,
	str_info_nickname: `ซื่อเล่น`,
	str_info_bankcard: `เลขบัญชีธนาคาร `,
	str_info_birthday: `วัน เกิด`,
	str_info_email: `E_mail`,
	str_maintain_maintain: `อยู่ระหว่างบำรุงรักษา อยู่ระหว่างบำรุงรักษา`,
	str_maintain_sorry: `ขออภัยในการไม่สะดวก`,
	str_activity_title: `กิจกรรม`,
	str_activity_tab1: `ทั้งหมด`,
	str_activity_tab2: `ใหม่ล่าสุด `,
	str_activity_tab3: `ผู้ใช้งานใหม่`,
	str_activity_tab4: `วิไอพี`,
	str_activity_tab5: `ประจำวัน`,
	str_activitydt_title: `ข้อมูลกิจกรรม`,
	str_login_title: `เข้าสู่ระบบ`,
	str_login_resSuccess: `เข้าสู่ระบบสำเร็จ`,
	str_login_registernew: `แวะชม`,
	str_login_registernew2: `ลงทะเบียนผู้ใช้งานใหม่`,
	str_login_forget: `ลืมรหัสผ่าน `,
	str_login_Login: `เข้าสู่ระบบ `,
	str_register_title: `ลงทะเบียน `,
	str_register_form_phonePl: `กรุญาใส่หมายเลขโทรศัพท์`,
	str_register_form_passwords: `กรุุญาตั้งรหัสผ่าน 6_20อักษร`,
	str_register_Download: `ดาวน์โหลดแอป `,
	str_register_Enter: `เข้าสู่เกม`,
	str_register_message_phone: `กรุญาใส่หมายเลขโทรศัพท์`,
	str_register_message_code: `กรุญาใส่รหัสยืนยัน`,
	str_register_message_password: `กรุญาใส่รหัสผ่าน`,
	str_register_message_pwdlen: `กรุุญาตั้งรหัสผ่าน 6_20อักษร`,
	str_register_message_pwdCon: `รหัสผ่าน2ครั้งไม่ตรงกัน `,
	str_register_message_pwd: `กรุุญาตั้งรหัสผ่านอีกครั้ง `,
	str_register_message_agress: `กรุณายืนยันข้อตกลงการให้บริการผู้ใช้`,
	str_register_Tick: `เลือกยืนยัน `,
	str_register_agreement: `ข้อตกลงการให้บริการผู้ใช้`,
	str_register_registernow: `ลงทะเบียนทันที `,
	str_register_existing: `ลงทะเบียนแล้ว เข้าสู่ระบบตอนนี้`,
	str_register_resSuccess: `ลงทะเบียนสำเร็จ`,
	str_register_getCode: `รับรหัสยีนยัน`,
	str_password_title: `รีเซ็ตรหัรผ่าน`,
	str_password_oldpassword: `กรุณาใส่รหัสผ่านเก่า`,
	str_password_newpassword: `กรุณาใส่รหัสผ่านใหม่`,
	str_password_password: `กรุณาใส่รหัสผ่านใหม่อีกครั้ง `,
	str_password_phone: `กรุญาใส่หมายเลขโทรศัพท์`,
	str_password_code: `กรุญาใส่รหัสยืนยัน`,
	str_password_getCode: `รับรหัสยีนยัน`,
	str_password_succeeded: `รีเซ็ตรหัรผ่านสำเร็จ `,
	str_password_Jump: `เปลี่ยนเส้นทางไปยังหน้าเข้าสู่ระบบ `,
	str_password_Enter: `เข้าสู่หน้า Log in `,
	str_password_Verify: `ยีนยันหมายเลขโทรศัพท์ `,
	str_password_rebuild: `รีเซ็ตรหัรผ่าน`,
	str_password_complete: `เสร็จสิ้น`,
	str_safety_title: `ตั้งรหัสการชำระ `,
	str_safety_pwd: `เปลี่ยนแปลงรหัสผ่านเข้าสู่ระบบ `,
	str_safety_payPwd: `ตั้งรหัสการถอน `,
	str_pwd_title: `เปลี่ยนแปลงรหัสผ่านเข้าสู่ระบบ `,
	str_service_title: `บริการลูกค้า`,
	str_service_contentOpen: `ลงทะเบียน `,
	str_service_contentzhuan: `ได้ทั้งเงินทั้งความมัน`,
	str_service_contentzhuce: `สบถามเพื่อลงทะเบียน`,
	str_service_contentfuwu: `บริการลูกค้าด้วยใจตลอด 24 ช.ม. `,
	str_my_title: `ของฉัน `,
	str_my_box_jiaoyi: `ประวัติธุรกรรม `,
	str_my_box_touzhu: `ประวัติการเดิมพัน`,
	str_my_box_dengji: `แลกคะแนนสะสม`,
	str_my_box_tuiguang: `เชิญโปรโมท`,
	str_my_balance: `ยอดคงเหลือ`,
	str_my_fanyong: `ยอดเครดิตเงินคืนวันนี้`,
	str_my_recharge: `ฝากยอด`,
	str_my_withdrawal: `ถอนยอด`,
	str_my_personal: `ข้อมูลส่วนตัว`,
	str_my_bank: `บัตรธนาคาน`,
	str_my_account: `ความปลอดภัยของบัญชีผู้ใช้งาน`,
	str_my_vip: ``,
	str_my_Download: `ดาวน์โหลดแอป `,
	str_my_news: `ข้อมูลส่วนตัว`,
	str_my_upgrade: `อัพเกรด`,
	str_my_eliminate: `ลบแคช `,
	str_my_out: `ออกจากระบบ`,
	str_withdrawal_binding: `กรุณาเลือกวิธีถอนยอด`,
	str_withdrawal_number: `เลขท้าย`,
	str_withdrawal_bankcard: `บัตรออมทรัพย์`,
	str_withdrawal_Disable: `ผู้ใช้งานถูกแบน `,
	str_withdrawal_balance: `ยอดคงเหลือ`,
	str_withdrawal_quota: `ยอดคงเหลือที่ถอนได้`,
	str_withdrawal_money: `ถอนยอด`,
	str_withdrawal_minimum: `ยอดข่ำต่ำที่ถอน`,
	str_withdrawal_withdraw: `กรุุณาใส่รหัสบีตรเพื่อถอนยอด`,
	str_withdrawal_regulations: `ยอดข่ำต่ำที่ถอน`,
	str_withdrawal_Withdrawals: `ถอนยอด`,
	str_withdrawal_Please_enter: `กรุญาใส่จำนวนยอดถอน`,
	str_withdrawal_Insufficient: `ยอดคงเหลือไม่เพียง`,
	str_withdrawal_greater_than: `จำนวนยอดที่ถอนต้องมากก่วา `,
	str_withdrawal_password: `กรุญณาใส่รหัสถอนยอด`,
	str_withdrawal_success: `ถอนยอดสำเร็จ`,
	str_withdrawal_set_up: `กรุณาตั้งรหัสถอนยอดก่อนทำรายการถอน`,
	str_withdrawal_choice: `กรุณาเลือกบัตรธนาคาร `,
	str_integral_title: `แลกคะแนนสะสม`,
	str_integral_IntegralIncrease: `คะแนนสะสมที่เพิ่มขึ้น`,
	str_integral_PointExchange: `แลกคะแนนสะสม`,
	str_integral_available: `คะแนนสะสมคงเหลือ`,
	str_integral_time: `เวลา`,
	str_integral_lable: `คะแนนสะสม`,
	str_spread_title: `เชิญโปรโมท`,
	str_spread_can: `ยอดเงินที่เลือกได้`,
	str_spread_amount: `ยอดเงินที่โอนเข้า`,
	str_spread_Cumulative: `ยอดคอมมิชชั่นสะสม `,
	str_spread_team: `จำำนวนคนในทีม`,
	str_spread_commission: `ค่าคอมมิชชั่นวันนี้`,
	str_spread_extension: `จำนวนคนที่โปรโมทวันนี้`,
	str_spread_Promotion: `ช่องทางโปรโมท 1 `,
	str_spread_Promotion2: `ช่องทางโปรโมท 2 `,
	str_spread_Promotion_link: `ลิงค์โปรโมท`,
	str_spread_copy: `ตัดลอกลิงค์แล้วส่งต่อให้เพื่อน`,
	str_spread_preservation: `เก็บQRโคดเชิญ `,
	str_spread_Commission: `คอมมิชชั่นคงเหลือยกเข้าบัญชี`,
	str_spread_notes: `คอมมิชชั่นคงเหลือยกเข้าบัญชี ถอนสดได้ `,
	str_spread_all: `ยกเข้าทั้งหมด`,
	str_spread_success: `บันทึกสำเร็จ `,
	str_spread_fail: `บันทึกไม่สำเร็จ`,
	str_spread_alls_all: `ทั้งหมด `,
	str_spread_alls_level: `ระดับ`,
	str_spread_alls_search: `ค้นหา`,
	str_spread_alls_account: `ซื่อผู้ใช้งาน `,
	str_spread_alls_generation: `รุ่นที่`,
	str_spread_alls_today: `ยอดรวมรายได้ `,
	str_spread_alls_team: `จำนวนคนในทีม`,
	str_record_trade: `บันทึกข้อมูลธุรกรรม `,
	str_record_betting: `เดิมพัน `,
	str_record_No_data: `ยังไม่พบข้อมูล`,
	str_record_searchText_0: `ภายในวันนี้ `,
	str_record_searchText_2: `ภายใน3วัน `,
	str_record_searchText_6: `ภายใน7วัน `,
	str_record_searchText_29: `ภายใน30วัน`,
	str_record_topText: `คัดเลือก`,
	str_record_betting_title: `ข้้อมูลประวัติการเดิมพัน `,
	str_bettingDetail_pingtai: `ซื่ื่อแพลตฟอร์ม`,
	str_bettingDetail_title: `ข้อมูลการเดิมพัน`,
	str_bettingDetail_name: `ซื่อเกม `,
	str_bettingDetail_channel: `ชนิดเกม`,
	str_bettingDetail_orderStatus: `สถานะ `,
	str_bettingDetail_gameType: `สถานะ `,
	str_bettingDetail_dateDesc: `เวลาเดิมพัน`,
	str_bettingDetail_accountDesc: `ยอดรวมเดิมพัน `,
	str_bettingDetail_lotteryAccount: `ยอดที่ถูกรางวัล `,
	str_bettingDetail_orderNo: `เลขที่การเดิมพัน`,
	str_bettingDetail_state0: `รวมยอดแล้ว`,
	str_bettingDetail_state1: `กำลังเดิมพัน `,
	str_bettingDetail_state2: `เดิมพันไม่สำเร็จ `,
	str_card_title: `บัตนรธนาคาร`,
	str_card_bankName: `ธนาคาร`,
	str_card_bankNamePl: `กรุณา เลือกบัตรธนาคาร`,
	str_card_bankNo: `เลขที่บัญชี ธนาคาร `,
	str_card_zskNo: `Faster Payment `,
	str_card_zskNo1: `กรุุณาใส่เลขFaster Payment `,
	str_card_bankNoPl: `กรุุณาใส่เลขบัตระนาคาร`,
	str_card_name: `ชื่อนามสกุล `,
	str_card_namePl: `กรุณาใส่ซื่อภาษาอังกฤษ `,
	str_card_tips: `ซื่อต้องตรงกับซื่อบัญชี หักไม่ตรงจะส่งผลทำให้ไม่สามารถถอยยอดได้ เปลี่ยนแปลงข้อมูลกรุณาติดต่อแอดมิน`,
	str_card_default: `บัตรธนาคาร`,
	str_card_choice: `เลือกธนาคาร`,
	str_card_Enterbankcard: `กรุณาใส่ซื่อธนาคารเพื่อค้นหา`,
	str_card_search: `ค้นหา`,
	str_card_binding: `ผูก `,
	str_record_trading_title: `ข้อมูลธุรกรรม`,
	str_record_trading_type: `หมวด`,
	str_record_trading_orderNo: `เลขที่บิล`,
	str_record_trading_dateTime: `เวลา`,
	str_record_trading_desc: `ข้อสังเกดการตรวจสอบ `,
	str_record_trading_progress: `ความคีบหน้าปัจจุบัน `,
	str_record_trading_copysuccess: `คัดลอกสำเร็จ`,
	str_record_trading_Recharge: `ฝากยอดสำเร็จ`,
	str_code_500: `ระบบไม่ว่าง`,
	str_code_4000: `ยังไม่ได้ลงซื่อเข้าใช้`,
	str_code_4001: `ข้้อมูลไม่ถูกต้อง `,
	str_code_4002: `รหัสยืนยันไม่ถูกต้อง `,
	str_code_4003: `ซื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง`,
	str_code_4004: `ไม่พบวิธี`,
	str_code_4005: `ไม่พบผู้ใช้งานนี้ `,
	str_code_4006: `ยังไม่ได้ยืนยันหมายเลขโทรศัพท์ `,
	str_code_4007: `หมายเลขโทรศัพท์นี้เคยลงทะเบียนแล้ว`,
	str_code_4008: `บัตรธนาคารนี้ไม่สามารถใช้งานได้`,
	str_code_4009: `ผูู้้ใช้งานนี้เคยผูกบัตรธนาคาร`,
	str_code_4010: `เข้าสู่ระบบไม่สำเร็จ `,
	str_code_4011: `มีการผูกกับวันเกิดแล้ว`,
	str_code_4012: `มีการผูกกับซื่อจริงแล้ว`,
	str_code_4013: `ยังไม่ได้ผูกบัตรธนาคารไว้`,
	str_code_4014: `บัตรธนาคารที่เลือกไม่ตรงกับบัตรธนาคารที่ผูกไว้ `,
	str_code_4015: `ผู้ใช้งานนี้ถูกแบน`,
	str_code_4016: `รับโบนัสไม่สำเร็จ`,
	str_code_4017: `ใส่รหัสผ่านเก่าไม่ถูกต้อง`,
	str_code_4018: `รหัสผ่านใหม่ตรงกับรหัสผ่านเก่า `,
	str_code_4019: `รหัสผ่านถอนยอดไม่ถูกต้อง`,
	str_code_4020: `รหัสผ่านถอนยอดใหม่ตรงกับรหัสผ่านถอนยอดเก่า `,
	str_code_4021: `ยังไม่ได้ตั้งรหัสผ่านถอนยอด `,
	str_code_4022: `ซื่อที่ลงทะเบียนไม่ตรงกับซื่อที่ผูก `,
	str_code_4023: `กิจกรรมยังไม่เริ่ม`,
	str_code_4024: `รับอั่งเปาไม่สำเร็จ`,
	str_code_4025: `ไม่มีอั่งเปานั้น`,
	str_code_4026: `ยังไม่ได้เปิดให้แลกอั่งเปา`,
	str_code_4027: `อั่งเปานี้ถูกรับไปแล้ว`,
	str_code_4028: `คุณมีผู้ใช้งานที่รับอั่งเปาไปแล้ว`,
	str_code_4029: `ยังไม่ถึงยอดฝากที่กำหนด `,
	str_code_4030: `ไม่มียอดเงินคืนที่รับได้`,
	str_code_4031: `คะแนนไม่เพียงพอ`,
	str_code_4032: `ภารกิจยังไม่บำเพ็ญ`,
	str_code_4033: `รางวัลนี้ถูกรับไปแล้ว`,
	str_code_4034: `รางวัลหมดอายุแล้ว `,
	str_code_4035: `ยังไม่ถึงเวลาที่กำหนด`,
	str_code_4036: `วันนี้ได้รับโบนัสไปแล้ว`,
	str_code_4037: `ไม่มีโบนัสคงเหลือ`,
	str_code_4043: `ไม่มีค่าคอมมิชชั่นคงเหลือ`,
	str_code_4044: `มีรายการค้างชำระเกินที่กำหนด กรุณาติอต่อติดต่อแอดมิน`,
	str_code_4045: `ส่งข้อความยืนยังไม่สำเร็จ กรุณาติอต่อติดต่อแอดมิน`,
	str_code_4046: `คุณมีราการถอนที่ยังไม่สำเร็จ กรุณารอการดำเนินการ`,
	str_name_title: `ซื่อจริง `,
	str_name_name: `ซื่อจริง `,
	str_name_namePl: `โปรดใส่ซื่อจริง `,
	str_name_tips: `ซื่อต้องตรงกับซื่อบัญชี หักไม่ตรงจะส่งผลทำให้ไม่สามารถถอยยอดได้ เปลี่ยนแปลงข้อมูลกรุณาติดต่อแอดมิน`,
	str_nick_title: `ซื่อเล่น `,
	str_nick_nick: `ซื่อเล่น `,
	str_nick_nickPl: `โปรดใส่ซื่อเล่น `,
	str_email_title: `ผูก e_mail`,
	str_email_email: `e_mail`,
	str_email_emailPl: `โปรดใส่่ e_mail`,
	str_facebook_title: `ผูกเฟสบุ๊ค`,
	str_facebook_facebook: `เฟสบุ๊ค `,
	str_facebook_facebookPl: `โปรดใส่บัญชีผู้ใช้เฟสบุ๊ค `,
	str_line_title: `ผูกไลน์ `,
	str_line_line: `ไลน์`,
	str_line_linePl: `ไอดีไลน์`,
	str_birthday_title: `ผูกวันเกิด`,
	str_birthday_birthday: `วันเกิด `,
	str_birthday_birthdayPl: `โปรดเลือกวัน เดือน ปี เกิด`,
	str_vipList_title: `รับของรางวัล`,
	str_vipList_tip: `โบนัสจากการเลื่อนขั้น`,
	str_vipList_yuan: `เงินดอลลาร์`,
	str_vipList_yi: `ได้รับแล้ว`,
	str_vipList_now: `รับทันที `,
	str_viprules_title: `กติกาการเลื่อนขั้น`,
	str_viprules_tip: `โบนัสจากการเลื่อนขั้น`,
	str_viprules_e: `ยอดเดิมพัน `,
	str_viprules_leiji: `ฝากยอด`,
	str_vip_title: `สิทธิพิเศษตามระดับ `,
	str_vip_content_current: `ยัอดเดิมพันปัจจุบัน`,
	str_vip_content_difference: `ยังขาด `,
	str_vip_content_Bet: `เดิมพันเพื่อจะเลื่อนขั้นถึง`,
	str_vip_content_receive: `รับโบนัสจากการเลื่อนขั้น`,
	str_vip_content_Betamount: `จำนวนเดิมพัน`,
	str_vip_content_Recharge: `ฝากยอด`,
	str_vip_content_Promotion: `โบนัสเลื่อนขั้น`,
	str_vip_content_vip: `สิทธิวีไอพี`,
	str_vip_content_see: `ดูทั้งหมด`,
	str_vip_content_Promotiongift: `โบนัสเลื่อนขั้น`,
	str_vip_content_More: `เพิ่มเติม`,
	str_vip_content_wait: `เร็วๆนี้ `,
	recharge_title: `ฝากยอด`,
	str_recharge_channel: `ช่องทาง`,
	str_recharge_choice: `เลือก`,
	str_recharge_zfb: `Alipay`,
	str_recharge_payment: `วิธีการชำระ `,
	str_recharge_money: `ยีอดฝาก`,
	str_recharge_Please: `โปรดใส่ยอดฝาก`,
	str_recharge_amount: `จำนวน`,
	str_recharge_yuan: `หยุน`,
	str_recharge_immediately: `ฝากยอดทันที`,
	str_recharge_order: `เลขที่คำสั่ง`,
	str_recharge_platform: `แพลตฟอร์ม `,
	str_recharge_username: `ซื่อผู้ใช้ `,
	str_recharge_account: `บัญชี`,
	str_recharge_copy: `คัดลอก `,
	str_recharge_payments: `ยีนยันการจ่าย`,
	str_recharge_dcWallet: `กระเป๋าเงินอิเล็กทรอนิกส์`,
	str_recharge_Tips: `คำเตือน `,
	str_with_title: `ถอน`,
	str_balance_title: `ข้อมูลยอดคงเหลือ`,
	str_balance_total: `ยอดรวม`,
	str_avatar_title: `รูปหน้า `,
	str_lucky_title: `โค้ดส่วนลด `,
	str_lucky_namePl: `โปรดใส่โค้ดส่วนลด `,
	str_lucky_tp: `ยินดีที่ได้รับอั่งเปา`,
	str_lucky_info: `ติดต่อแอดมินเพื่อจะรับโค้ดส่วนลด`,
	str_lucky_bot: `โบนัสสูงสุด 5866หยุน`,
	str_lucky_tips: `หลังจากฝากยอด1ยอด สามารถรับโบนัสได้`,
	str_lucky_resSuccess: `รับยอดสำเร็จ`,
	str_rebate_title: `โบนัส`,
	str_rebate_btn: `โบนัส วีไอพี`,
	str_rebate_lingqu: `ได้รับโบนัส `,
	str_rebate_footTip: `ยอดที่รับได้วันนี้ `,
	str_rebate_table: `เวลา /ซื่อเกม/ ยอดเติม/ อัตราส่วนเงินคืน/ ยอดเงินคืน /สถานะ `,
	str_vip_rebate_title: `โบนัส วีไอพี`,
	str_vip_rebate_vip: `ระดับ วีไอพี`,
	str_log_titleW: `ประวัติถอนยอด `,
	str_log_titleR: `ประวัติฝากยอด `,
	str_log_amount: `จ่ำนวน`,
	str_log_Application: `เวลาใช้ในการสมัคร`,
	str_log_Audit: `เวลาในการอนุมัติ`,
	str_log_state: `สถานะ `,
	str_log_Tobepaid: `อยู่ระหว่างการจ่ายเงิน `,
	str_log_success: `สำเร็จ`,
	str_log_Paid: `จ่ายแล้ว`,
	str_log_close: `ปิด `,
	str_log_launch: `ยืนยังถอนยอด`,
	str_log_WithdrawalSucceeded: `ถอนสำเร็จ`,
	str_log_WithdrawalFailed: `ถอนไม่สำเร็จ`,
	str_log_remarks: `ข้อสังเกต`,
	str_log_nothing: `ไม่มี`,
	str_log_shenhe: `อยู่ในระหว่างการอนุมัติ `,
	str_rush_title: `หััวข้อ`,
	str_phone_title: `หััวข้อ`,
	str_lower_title: `หััวข้อ`,
	str_achievememt_title: `หัวข้อ`,
	str_achievememt_account: `บัญชีผู้ใช้`,
	str_achievememt_directly: `โดยตรง`,
	str_achievememt_achievement: `ยอดขาย`,
	str_achievememt_newly: `เพิ่ม`,
	str_achievememt_team: `ทีม `,
	str_achievememt_income: `รายได้ `,
	str_achievememt_commission: `ค่าคอมมิชชั่น`,
	str_achievememt_detailed: `รายละเอียด`,
	str_achievememt_item: `เวลาที่กำหนด`,
	str_achievememt_user: `ชื่อสมาชิก`,
	str_achievememt_date: `วันที่`,
	str_memberdetails_title: `ข้อมูลสมาชิก`,
	str_team_title: `ค่าคอมมิชชั่นทีม `,
	str_message_title: `ข่าวสาร`,
	str_message_system: `ระบบ`,
	str_message_business: `ข่าวสาร`,
	str_message_Loading: `กำลังโหลด`,
	str_message_No: `สิ้นสุดข้อความ`,
	str_msg_title: `รายละเอียด`,
	str_game_list_title: `สล็อต`,
	str_update_edition: `แจ้งเตือนอัปเดต`,
	str_update_Updating: `กำลังอัปเดต `,
	str_update_progress: `สถานะการอัพเกรด `,
	str_update_fail: `อัปเดตล้มเหลว `,
	str_update_determine: `ยืนยันอัปเดต`,
	str_index_top: `GB`,
	str_top_content: `ความบันเทิงสด เดิมพันกีฬา เกมอิเล็กทรอนิกส์เพียงปลายนิ้วสัมผัส`,
	str_top_xiazai: `โหลดทันที`,
	str_Totalbet: `เดิมพันทั้งหมด`,
	str_Totalwinorlose: `รวมชนะ`,
	str_record_platform: `แพลตฟอร์ม`,
	str_record_platform: `เดิมพันที่ถูกต้อง`,
	str_winorlose: `ชนะหรือแพ้`,
	str_record_zhudan: `เดิมพัน`,
	str_trade_all: `ทั้งหมด`,
	str_trade_caijin: `แจ็คพอต`,
	str_trade_tixian: `ถอน`,
	str_trade_chongzhi: `เติมเงิน`,
	str_trade_fanyong: `เงินคืน`,
	str_trade_erdu: `การแปลงโควต้า`,
	str_trade_shoudong: `เติมเงินด้วยตนเอง`,
	str_trade_cengjin: `โบนัสเติมเงิน`,
	str_trade_tuihui: `การถอนและคืนสินค้า`,
	str_spread_suoyou: `ลูกน้องทุกคน`,
	str_spread_tuandui: `ผลงานของทีม`,
	str_spread_fanyong: `อัตราส่วนเงินคืน`,
	str_qukuan: `กรุณาใส่รหัสผ่านเข้าสู่ระบบ`,
	str_qukuan_mima: `กรุณาใส่รหัสผ่านการถอนเดิม`,
	str_login_forget2: `หากคุณลืมรหัสผ่านเข้าสู่ระบบของคุณ`,
	str_chongzhi: `รีเซ็ตรหัสผ่าน`,
	str_qukuanmima: `หากคุณลืมรหัสผ่านการถอนเดิม โปรด`,
	str_lianxi: `ติดต่อฝ่ายบริการลูกค้า`,
	str_wenxin: `เคล็ดลับ`,
	str_card_tishi: `สมาชิกสามารถผูกบัญชีบัตรธนาคารและบัญชี FPS ได้ 1 บัญชีเท่านั้น และชื่อเจ้าของบัญชีจะต้องเป็นชื่อเดียวกัน หากคุณต้องการแก้ไขหลังจากผูกมัดแล้ว โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์ตลอด 24 ชั่วโมงของเรา`,
	str_service_contentchongzhi: `Recharge consultation`,
	str_my_zhanghao: `Account number`,
	str_go_index: `กลับไปที่หน้าแรก`,
	str_tiem_chaxun: 'Query days cannot be greater than 30 days',
	str_Platform_name: 'Platform name',
	str_Bet_amount: `Bet amount`,
	str_Other_games: `Other games`,
	str_Reset: 'Reset',
	str_less_than: 'The query interval must be less than 30 days',
	str_What_level: `What level`,
	str_fishing: 'fishing',
	str_Electronics: 'Electronics',
	str_Chess_cards: 'Chess and cards',
	str_lottery: `lottery`,
	str_Real_person: `Real person`,
	str_Sports: `Sports`,
	str_Copy_link: `Copy connection to friends`,
	str_withdrawal_mode: 'กรุณาเลือกวิธีการนำเสนอ',
	str_bank_card: 'บัตรธนาคาร',
	str_vip_content_betRecharge: 'ค่าใช้จ่ายในปัจจุบัน',
	str_vip_content_Bet2: 'เติมเงินเพื่ออัพเกรด',
	str_vip_leves: 'การอัพเกรดจะต้องตอบสนองใดๆของเงื่อนไขต่อไปนี้',
	str_vip_leves2: 'การอัพเกรดต้องตอบสนองสองเงื่อนไข',
	str_first_charge: 'Todays first charge amount:',
	str_received: 'Todays bonus:',
	str_Require: 'First deposit amount requirement',
	str_give_away: 'Gift bonus',
	str_xima_fanli: 'Shuffle code rebate',
	str_maintain: 'This platform is under maintenance, please change to another platform to play the game',
	str_rebate_table1: `Time`,
	str_rebate_table2: `Game name`,
	str_rebate_table3: `Code washing quantity`,
	str_rebate_table4: `Return water ratio`,
	str_rebate_table5: `Return water color gold`,
	str_rebate_table6: `Status`,
	str_wan: '',
	str_one_chong: 'ค่าใช้จ่ายครั้งแรก',
	str_recharge_chongzhi: 'ช่องเติมเงิน',
	str_recharge_card: 'หมายเลขบัตรชำระเงิน',
	str_xima_shouming: 'Event Description',
	str_xima_1: '1. ลำดับการเติมเงินครั้งแรกรายวันมากกว่า 100.00 และโบนัสจะได้รับรางวัล ',
	str_xima_2: '2. ยิ่งโบนัสเงินฝากสูง ยิ่งให้โบนัสมาก ดูรายละเอียดในตาราง ',
	str_xima_3: '3. เวลารีเฟรชกิจกรรม, 0:00 ทุกวัน. ',
	str_xima_4: '4. สามารถดูบันทึกการเคลมได้ในบันทึกธุรกรรม ',
	str_qianbao_guanli: 'การจัดการกระเป๋าสตางค์',
	str_massge_my: 'ข้อความของฉัน',
	str_go_login: 'ไปที่เข้าสู่ระบบ',
	str_no_login: 'ไม่ได้ลงชื่อเข้าใช้',
	str_one_chong: 'การเรียกเก็บเงินครั้งแรก',
	str_xima_5: '2 ส่วนลดรหัส นาฬิกาทุกวันคำนวณเงินคืนในการเดิมพันของวันก่อนหน้า',
	str_xima_6: '2. อัตราส่วนเงินคืน "50" หมายถึง 50 สำหรับทุก ๆ 10,000 เดิมพันที่ถูกต้อง',
	str_rebate_wei: 'ไม่ถึงมาตรฐาน',
	str_vip_rebate_title2: 'คำอธิบายกิจกรรม',
	str_download_copy: 'คัดลอกลิงค์',
	str_tigong: 'มอบไคลเอนต์มือถือที่ดีที่สุดแก่คุณ',
	str_suixing: 'การเดินทางบนมือถือ ให้คุณสนุก',
	str_baocun: 'บันทึกรหัส QR',
	str_balance:'สมดุล',
	str_colose: 'ปิด',
	str_index:'หน้าแรก',
	str_about:'เกี่ยวกับเรา',
	str_service:'บริการผลิตภัณฑ์เกม',
	str_service_desc:'ขอบคุณที่ใช้ผลิตภัณฑ์และบริการเกม SWG SWG ให้บริการวิดีโอเกมระดับมืออาชีพ เรามีประสบการณ์เกมที่หลากหลาย และ API เกมมากกว่า 50 รายการนำประสบการณ์เกมที่ดีที่สุดมาให้คุณ!',
	str_multivariate:'ความบันเทิงที่หลากหลาย',
	str_multivariate_desc:'ครอบคลุมการพัฒนาสล็อตแมชชีน เครื่องตกปลา เกมขนาดเล็ก ลอตเตอรีอิเล็กทรอนิกส์ และเกมอิเล็กทรอนิกส์ประเภทอื่น ๆ โดยเฉพาะอย่างยิ่งเกมสล็อตแมชชีนและเกมเครื่องตกปลา',
  str_jump_height: 'Jump Height',
  str_jump_amount: 'Jump Amount',
  str_special_Games: 'เกมพิเศษ:',
  str_three_yuan: 'จงฟาไป๋',
  str_luckiest_man: 'วันเกิดปีที่สี่',
  str_lightning_jet: 'Lightning Jet',
  str_none:'ไม่มี',


}



// WEBPACK FOOTER //
// ./src/VueI18n/language-tn.js